// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236b7280%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background: #edf4ff !important;
  --supportBlack: #303030 !important;
  --light: #6a6969 !important;
  --primary: #2f3293 !important;
  --blue: #3a57e8 !important;
  --lightBlue: #1890ff !important;
  --supportRed: #ff4d4f !important;
  --tableBg: #f7fbff !important;
  --purple: #605bff !important;
  --red: #ff3b30 !important;
  --green: #34c759 !important
;
}

body {
  margin: 0;
  font-family: "Nunito", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--background) !important;
}

code {
  font-family: "Nunito", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin-bottom: 0px !important;
}

.cursor-pointer {
  cursor: pointer;
}

/* ----------React Select box Css ----------------- */
.css-1u9des2-indicatorSeparator {
  background-color: transparent !important;
}

.css-894a34-indicatorSeparator {
  background-color: transparent !important;
  color: black;
}
.css-olqui2-singleValue {
  color: black !important;
}

.css-1vz0vyx-control {
  background-color: rgb(238, 238, 238);
  opacity: 70%;
}

/* -------------------- */

/* --------------Comman Box Shadow ------------ */
.comman-box-shadow {
  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;
}

/* ------------------- */

/* ------------------------Text Color Css --------------------------------- */
.redColor {
  color: var(--red) !important;
  font-weight: 600;
}
.lightBlueColor {
  color: var(--lightBlue) !important;
  font-weight: 600;
}

.greenColor {
  color: var(--green) !important;
  font-weight: 600;
}
.yellowColor {
  color: #faad14 !important;
  font-weight: 600;
}
/* ------------- */

/* -----------------table css -------------------- */
.tableWrapper {
  background-color: #ffffff;
  width: 100%;
  overflow: auto;
  border: 1px solid var(--blue);
  border-radius: 10px !important;
  position: relative;
}

.tableWrapper > table {
  width: 100%;
  table-layout: auto;
  border-radius: 10px !important;
}

.tableWrapper > table td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tableWrapper > table > thead {
  width: 100%;
}

.tableWrapper > table > thead th {
  height: 50px;
  padding: 0px 12px;
  background-color: var(--blue);
  color: #fff;
  font-weight: 500;
  position: sticky;
  top: 0px;
  z-index: 12;
}

.tableWrapper > table > tbody td {
  font-weight: 600;
  padding: 10px 8px;
}

.skyBlueTrBg {
  background-color: rgba(48, 176, 199, 0.1);
}
.whiteTrBg {
  background-color: #ffffff;
}

.table_row_color {
  background-color: #f7f6fe;
}

.col_80px {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.col_100px {
  min-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.col_120px {
  min-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_150px {
  min-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_190px {
  min-width: 190px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.col_200px {
  min-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_220px {
  min-width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_250px {
  min-width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_300px {
  min-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_350px {
  min-width: 350px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_400px {
  min-width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* ------------------------- */

/* ------------------ Srollbar Css ------------------ */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  padding: 2px;
}

::-webkit-scrollbar-thumb {
  background-color: var(--blue);
  border-radius: 10px;
  height: 5px;
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #e0e6eb;
  width: 5px;
  height: 5px;
  padding: 2px;
  box-shadow:
    rgb(183, 197, 210) 3px 3px 6px 0px inset,
    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;
}

/* --------------------- */

/* ----------Page and card Wrapper Css --------------- */
.pageWrapper {
  margin: 20px 30px;
}

.cardWrapper {
  padding: 24px;
  margin: 24px;
  border-radius: 10px;
  background-color: #fff;
}
/* ----------------- */

/* ---------------Tooltop Css --------------------- */
.tooltip {
  background-color: #fff !important;
  color: black !important;
  box-shadow:
    rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px !important;
  opacity: 100% !important;
  padding: 14px !important;
}

/* -----------Spreadsheet__data-viewer ----------- */
.Spreadsheet__data-viewer {
  color: black;
}
.Spreadsheet__cell,
.Spreadsheet__header {
  text-align: center !important;
  font-size: 8px !important;
  /* border: 1px solid red !important; */
  width: 10px !important;
  min-width: 10px !important;
  max-height: auto !important;
  height: 200px !important;
  overflow: none;
  text-wrap: wrap;
}

.Spreadsheet__header {
  font-size: 8px !important;
  width: 30px !important;
  height: 20px !important;
}

.Spreadsheet__header,
.Spreadsheet__data-viewer,
.Spreadsheet__data-editor input {
  padding: 0px !important;
  margin: 0px !important;
  width: 20px !important;
}

.form-check {
  min-height: 0px !important;
}
@media (min-width: 1000px) {
  .row-fix-to-last {
    position: sticky !important;
    right: 0px;
    z-index: 10 !important;
    box-shadow: -6px 0 15px rgba(47, 50, 153, 0.08) !important;
    transition: all 0.3s ease;
  }

  th.row-fix-to-last {
    position: sticky !important;
    top: 0px !important;
    right: 0px !important;
    z-index: 20 !important;
    background-color: #2f3299 !important;
    color: #ffffff !important;
    font-weight: 700 !important;
    text-align: center !important;
    border-left: 1px solid rgba(255, 255, 255, 0.15) !important;
  }

  td.row-fix-to-last {
    background-color: #f0f3fc !important;
    border-left: 1px solid rgba(47, 50, 153, 0.08) !important;
  }

  tr.skyBlueTrBg td.row-fix-to-last {
    background-color: #e8ebf8 !important;
  }
}

/* Premium Action Pill Buttons */
.premiumActionBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 30px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff !important;
  cursor: pointer;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.06),
    0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;
  text-decoration: none !important;
}

.premiumActionBtn:hover {
  transform: translateY(-1.5px);
  box-shadow:
    0 6px 12px rgba(0, 0, 0, 0.1),
    0 4px 6px rgba(0, 0, 0, 0.1);
  color: #ffffff !important;
}

.premiumActionBtn:active {
  transform: translateY(0);
}

.premiumActionBtn.edit {
  background-color: #278e3c !important; /* Forest green */
}

.premiumActionBtn.edit:hover {
  background-color: #1e702e !important;
}

.premiumActionBtn.view {
  background-color: #2f3299 !important; /* Deep brand blue */
}

.premiumActionBtn.view:hover {
  background-color: #242678 !important;
}

.premiumActionBtn svg {
  width: 14px;
  height: 14px;
  fill: none !important;
}

.premiumActionBtn.edit svg,
.premiumActionBtn.view svg {
  stroke: #ffffff !important;
}
@media (max-width: 1000px) {
  .tableWrapper > table > thead th {
    height: 42px;
    font-size: 14px;
  }
  .tableWrapper > table > tbody td {
    font-weight: 600;
    padding: 8px 8px;
    font-size: 14px;
  }
}
@media (max-width: 750px) {
  .tableWrapper > table > thead th {
    height: 34px;
    font-size: 12px;
  }
  .error-message {
    font-size: 12px;
  }

  .col_100px {
    width: 60px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .col_150px {
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .col_200px {
    width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .col_250px {
    width: 170px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .col_300px {
    width: 220px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .col_350px {
    width: 280px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .col_400px {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tableWrapper > table > tbody td {
    font-weight: 600;
    font-size: 12px;
  }
  .tableWrapper > table > tbody td svg {
    width: 24px;
    height: 24px;
  }
  .cardWrapper {
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    background-color: #fff;
  }

  .css-84ol4x-control {
    height: 44px !important;
    font-size: 14px;
  }
}

/* --------- Premium Select Box ------------- */
.premium-select-mine {
  appearance: none;
  background-color: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 32px 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
}

.premium-select-mine:hover {
  border-color: #9ca3af;
  background-color: #ffffff;
}

.premium-select-mine:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  background-color: #ffffff;
}

/* --------- New Layout Styles ------------- */
.mainLayoutWrapper {
  display: flex;
  height: 100vh;
  width: 100vw;
  background-color: #ffffff;
  overflow: hidden;
}

/* Sidebar */
.sidebar {
  width: 280px;
  background-color: #2f3299;
  display: flex;
  flex-direction: column;
  color: white;
  height: 100%;
  flex-shrink: 0;
}

.sidebarLogoContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px 20px;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.sidebarLogoBg {
  background-color: white;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.sidebarLogoBg img {
  width: 60px;
}

.sidebarLogoContainer h1 {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
}

.sidebarLogoContainer p {
  font-size: 10px;
}

.sidebarNav {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.sidebarNav::-webkit-scrollbar {
  display: none;
}

.sidebarActiveIndicator {
  /* margin-top: 15px; */
  position: absolute;
  top: 0;
  left: 20px;
  right: 0;
  height: 56px;
  background-color: #ffffff;
  border-radius: 40px 0 0 40px;
  transition:
    transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1),
    height 0.3s ease;
  z-index: 0;
  pointer-events: none;
  border-color: transparent;
}

.sidebarActiveIndicator::before {
  content: "";
  position: absolute;
  top: -40px;
  right: -1px;
  width: 40px;
  height: 41px;
  background: radial-gradient(circle at top left, transparent 40px, #ffffff 40.5px);
  pointer-events: none;
  border-color: transparent;
}

.sidebarActiveIndicator::after {
  content: "";
  position: absolute;
  bottom: -40px;
  right: -1px;
  width: 40px;
  height: 41px;
  background: radial-gradient(circle at bottom left, transparent 40px, #ffffff 40.5px);
  pointer-events: none;
  border-color: transparent;
}

.sidebarNavItem {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  color: #fff;
  transition: all 0.3s;
  border-radius: 40px 0 0 40px;
  margin-left: 20px;
  position: relative;
  z-index: 1;
  border-color: transparent;
}

.sidebarNavItem .navIcon svg,
.sidebarNavItem .navIcon svg path {
  fill: #fff !important;
  stroke: #fff !important;
  transition: all 0.3s;
}
.sidebarNavItem .navIcon {
  display: flex;
  margin-right: 15px;
}
.sidebarNavItem .navIcon svg {
  width: 24px;
  height: 24px;
}

.sidebarNavItem .navText {
  font-size: 16px;
  font-weight: 500;
}

.sidebarNavItem.active {
  color: #2f3299;
  font-weight: bold;
}

.sidebarNavItem.active .navIcon svg,
.sidebarNavItem.active .navIcon svg path {
  fill: #2f3299 !important;
  stroke: #2f3299 !important;
}

.sidebarFooter {
  padding: 20px;
}

.sidebarDivider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  margin-bottom: 20px;
}

.logoutBtn {
  background-color: white;
  color: #ff4d4f;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
}

.logoutBtn .logoutIcon svg path {
  fill: #ff4d4f !important;
}

.logoutBtn:hover {
  background-color: #ffe6e6;
}

/* Main Content Area */
.mainLayoutRight {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

/* Header */
.mainHeaderWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background-color: #ffff;
  z-index: 10;
}

.headerSearch {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px 15px;
  width: 100%;
  max-width: 600px;
  border: 1px solid #2f3299;
  box-shadow: 0px 0px 12.89px 0px #56555540;
}

.headerSearch input {
  border: none;
  background: transparent;
  outline: none;
  flex: 1 1;
  font-size: 14px;
}

.headerSearch .searchIcon {
  color: #888;
}

.headerRight {
  display: flex;
  align-items: center;
  gap: 20px;
}

.mineStatus {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #fff;
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  color: #555;
  border: 1px solid #4547a1;
}
.mineStatus span {
  color: #4547a1;
  font-weight: 500;
}

.statusDot {
  width: 18px;
  height: 18px;
  background-color: #34c759;
  border-radius: 50%;
}

.notificationIcon {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  /* border: 2px solid #2f3299; */
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.notificationBadge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff4d4f;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: bold;
}

.profileIcon {
  cursor: pointer;
}

/* Page Content */
.mainContentArea {
  flex: 1 1;
  padding: 0 30px 30px;
  overflow-y: auto;
  background-color: #ffff;
}

.pageWrapper {
  margin: 0 !important;
  background-color: #4547a11c;
  border-radius: 10px;
  padding: 5px 20px;
}
.pageWrapperWhite {
  margin: 0 !important;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
}

.cardWrapper {
  margin: 0 !important;
}

/* Modifying table styles for new theme */
.tableWrapper > table > thead th {
  background-color: #2f3299 !important;
  color: #ffffff;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.tableWrapper > table > tbody td {
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
  background-color: #fff;
}

/* Pagination Styles */
.paginationContainer {
  font-family: "Nunito", sans-serif;
}

.prevNextBtn {
  background-color: transparent;
  border: 1px solid #ccc;
  color: #555;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.prevNextBtn:hover:not(:disabled) {
  background-color: #f0f0f0;
}

.prevNextBtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pageNumberBtn {
  background-color: transparent;
  border: 1px solid #ccc;
  color: #555;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.pageNumberBtn:hover {
  background-color: #f0f0f0;
}

.pageNumberBtn.active {
  background-color: #2f3299;
  color: white;
  border-color: #2f3299;
}

/* New Premium Pagination styling matching the screenshot */
.premiumPaginationWrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.premiumPaginationInput {
  width: 48px;
  height: 36px;
  border: 1px solid #ccc;
  background-color: #ffffff;
  color: #1d1d1d;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  outline: none;
  border-radius: 0px; /* Square as in the screenshot */
  transition: border-color 0.2s;
}

.premiumPaginationInput:focus {
  border-color: #2f3299;
}

/* Chrome, Safari, Edge, Opera: Remove spin arrows */
.premiumPaginationInput::-webkit-outer-spin-button,
.premiumPaginationInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox: Remove spin arrows */
.premiumPaginationInput[type="number"] {
  -moz-appearance: textfield;
}

.premiumPaginationText {
  color: #757575;
  font-size: 16px;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
}

.premiumPaginationBtn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition:
    background-color 0.2s,
    opacity 0.2s;
}

/* Enabled Active Next/Prev Button (Dark Blue/Purple) */
.premiumPaginationBtn.btnActive {
  background-color: #2f3299;
  color: #ffffff;
}

.premiumPaginationBtn.btnActive:hover {
  background-color: #242678;
}

/* Disabled Faded Next/Prev Button (Light Purple/Blue) */
.premiumPaginationBtn:disabled {
  background-color: #a2aed6;
  color: #ffffff;
  cursor: not-allowed;
}

.premiumPaginationBtn svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* Premium Filter Bar Layout matching screenshot */
.premiumFilterBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 20px;
  background-color: transparent;
}

.premiumFilterLeft {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.premiumFilterRight {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Dropdown Filters and Buttons */
.premiumFilterDropdown .dropdown-toggle::after,
.premiumExportDropdown .dropdown-toggle::after {
  display: none !important; /* Hide bootstrap default caret */
}

.premiumFilterToggle,
.premiumDatePickerWrapper,
.premiumExportToggle {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff !important;
  border: 1.5px solid #dcdcdc;
  border-radius: 8px;
  padding: 8px 16px;
  color: #2f3299 !important;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  height: 40px;
  -webkit-user-select: none;
          user-select: none;
}

.premiumDatePickerWrapper > svg:first-of-type {
  width: 20px !important;
  height: 18px !important;
}

.premiumFilterToggle {
  min-width: 130px;
}

.premiumFilterToggle:hover,
.premiumDatePickerWrapper:hover,
.premiumExportToggle:hover {
  border-color: #2f3299;
  box-shadow: 0px 6px 14px rgba(47, 50, 153, 0.1);
}

.premiumFilterCaret,
.premiumDatePickerCaret {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: #2f3299;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  margin-left: 12px;
}

.premiumCalendarIcon {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: #2f3299;
  stroke-width: 2;
  margin-right: 10px;
}

/* Custom Checkbox dropdown list */
.premiumFilterMenu {
  border: none !important;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px !important;
  padding: 8px 0 !important;
  min-width: 180px !important;
}

.premiumFilterItem {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.premiumFilterItem:hover {
  background-color: #f5f6ff;
}

.premiumFilterCheckbox {
  cursor: pointer;
  accent-color: #2f3299;
  width: 16px;
  height: 16px;
}

.premiumFilterItemLabel {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}

/* Invisible standard date picker cover */
.premiumDatePickerWrapper {
  position: relative;
  min-width: 140px;
  display: flex;
  align-items: center;
}

.premiumDatePickerInput {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.premiumDatePickerLabel {
  font-size: 13px;
  font-weight: 600;
  color: #2f3299;
}

/* Solid Reset button */
.premiumResetBtn {
  background-color: #2f3299;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 8px 24px;
  font-size: 15px;
  font-weight: 600;
  height: 40px;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0px 4px 12px rgba(47, 50, 153, 0.2);
  transition: all 0.2s ease-in-out;
}

.premiumResetBtn:hover {
  background-color: #21236b;
  box-shadow: 0px 6px 16px rgba(47, 50, 153, 0.3);
}

/* Export dropdown specific styles */
.premiumExportToggle {
  border-color: #2f3299;
  background-color: #ffffff;
  color: #2f3299;
  min-width: 110px;
  box-shadow: 0px 4px 10px rgba(47, 50, 153, 0.08);
}

.premiumExportToggle:hover {
  background-color: #2f3299;
  color: #ffffff;
}

.premiumExportToggle:hover .premiumExportIcon {
  stroke: #ffffff;
}

.premiumExportIcon {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: #2f3299;
  stroke-width: 2.5;
  margin-left: 10px;
  transition: stroke 0.2s;
}

.premiumExportMenu {
  border: none !important;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px !important;
  padding: 8px 0 !important;
  min-width: 150px !important;
}

.premiumExportMenu a {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568 !important;
  padding: 8px 16px !important;
  transition: background-color 0.2s;
}

.premiumExportMenu a:hover {
  background-color: #f5f6ff !important;
  color: #2f3299 !important;
}

/* Premium Form Styling (Add Shift etc.) */
.premiumFormContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 0;
}

.premiumFormHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
  text-align: center;
}

.premiumFormHeaderIcon {
  width: 48px;
  height: 48px;
  background-color: #2f3299;
  color: #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  box-shadow: 0px 4px 12px rgba(47, 50, 153, 0.2);
}

.premiumFormHeaderIcon svg {
  width: 24px;
  height: 24px;
  stroke: currentColor;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}

.premiumFormHeader h2 {
  font-size: 28px;
  font-weight: 700;
  color: #2f3299;
  margin: 0 0 6px 0;
}

.premiumFormHeader p {
  font-size: 14px;
  color: #718096;
  margin: 0;
}

.premiumFormCard {
  background-color: #ffffff;
  border: 1.5px solid #a2aed6;
  border-radius: 16px;
  padding: 32px;
  width: 100%;
  box-shadow: 0px 8px 30px rgba(47, 50, 153, 0.08);
  margin-bottom: 32px;
  transition:
    border-color 0.3s ease,
    box-shadow 0.3s ease;
}

.premiumFormCard:hover {
  border-color: #2f3299;
  box-shadow: 0px 10px 35px rgba(47, 50, 153, 0.12);
}

.premiumFormGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.premiumFieldGroup {
  display: flex;
  flex-direction: column;
}

.premiumFieldLabel {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.premiumInput {
  height: 44px;
  border: 1px solid #2f3293;
  border-radius: 8px;
  padding: 0 16px;
  font-size: 15px;
  color: #2d3748;
  background-color: #ffffff;
  outline: none;
  transition:
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
}

.premiumInput:focus {
  border-color: #2f3299;
  box-shadow: 0px 0px 0px 3px rgba(47, 50, 153, 0.1);
}

.premiumInput:disabled {
  border: 1px solid #2f3293;
  color: #718096;
  border-color: #2f3293;
  cursor: not-allowed;
}

/* Custom Time Pickers row */
.premiumTimePickersRow {
  display: flex;
  gap: 10px;
  width: 100%;
}

.premiumTimePickerWrapper {
  position: relative;
  flex: 1 1;
  height: 44px;
  border: 1.5px solid #a2aed6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background-color: #ffffff;
  cursor: pointer;
  transition:
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
}

.premiumTimePickerWrapper:hover {
  border-color: #2f3299;
}

.premiumTimePickerInput {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.premiumTimePickerLabel {
  font-size: 15px;
  font-weight: 500;
  color: #4a5568;
}

.premiumTimePickerCaret {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: #4a5568;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.premiumTimePickerIcon {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: #2f3299;
  stroke-width: 2;
  margin-right: 10px;
}

/* Centered buttons at the bottom */
.premiumButtonsWrapper {
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
}

.premiumBtnCancel {
  height: 46px;
  min-width: 160px;
  background-color: #ffffff;
  border: 1.5px solid #2f3299;
  color: #2f3299;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0px 4px 10px rgba(47, 50, 153, 0.05);
}

.premiumBtnCancel:hover {
  background-color: #f5f6ff;
  box-shadow: 0px 6px 14px rgba(47, 50, 153, 0.1);
}

.premiumBtnSubmit {
  height: 46px;
  min-width: 160px;
  background-color: #2f3299;
  border: none;
  color: #ffffff;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0px 4px 14px rgba(47, 50, 153, 0.2);
}

.premiumBtnSubmit:hover {
  background-color: #21236b;
  box-shadow: 0px 6px 18px rgba(47, 50, 153, 0.35);
}

/* Premium Form Card InputBox CSS overrides */
.premiumFormCard .inputBoxWrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.premiumFormCard .inputBoxWrapper label {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0;
}

.premiumFormCard .inputBoxWrapper input {
  height: 44px !important;
  border: 1.5px solid #a2aed6 !important;
  border-radius: 8px !important;
  padding: 0 16px !important;
  font-size: 15px !important;
  color: #2d3748 !important;
  background-color: #ffffff !important;
  outline: none !important;
  transition:
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out !important;
}

.premiumFormCard .inputBoxWrapper input:focus {
  border-color: #2f3299 !important;
  box-shadow: 0px 0px 0px 3px rgba(47, 50, 153, 0.1) !important;
}

.premiumFormCard .inputBoxWrapper input:disabled {
  background-color: #f7fafc !important;
  color: #718096 !important;
  border-color: #e2e8f0 !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}

/* Logout Custom Popup CSS */
.logoutPopupDialog .modal-content {
  border-radius: 24px !important;
  border: none !important;
  padding: 32px 24px !important;
  text-align: center !important;
  background-color: #ffffff !important;
  max-width: 440px !important;
  margin: auto !important;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.12) !important;
}

.logoutPopupTitle {
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #000000 !important;
  margin-bottom: 12px !important;
  text-align: center !important;
}

.logoutPopupText {
  font-size: 15px !important;
  font-weight: 500 !important;
  color: #718096 !important;
  margin-bottom: 24px !important;
  text-align: center !important;
}

.logoutPopupButtons {
  display: flex !important;
  justify-content: center !important;
  gap: 16px !important;
  width: 100% !important;
}

.logoutPopupBtnCancel {
  height: 44px !important;
  flex: 1 1 !important;
  max-width: 140px !important;
  background-color: #ffffff !important;
  border: 1.5px solid #2f3299 !important;
  color: #2f3299 !important;
  border-radius: 12px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.2s ease-in-out !important;
}

.logoutPopupBtnCancel:hover {
  background-color: #f5f6ff !important;
}

.logoutPopupBtnConfirm {
  height: 44px !important;
  flex: 1 1 !important;
  max-width: 140px !important;
  background-color: #c90000 !important;
  border: none !important;
  color: #ffffff !important;
  border-radius: 12px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.2s ease-in-out !important;
}

.logoutPopupBtnConfirm:hover {
  background-color: #a80000 !important;
}

/* Custom Premium Date Pickers */
.premiumFilterBar .premiumDatePickerWrapper {
  flex: none !important;
  height: 40px !important;
}

.premiumDatePickerWrapper {
  position: relative;
  flex: 1 1;
  height: 48px !important;
  border: 1.5px solid #a2aed6 !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 8px !important;
  background-color: #ffffff !important;
  cursor: pointer !important;
  transition: border-color 0.2s ease-in-out !important;
}

.premiumDatePickerWrapper:hover {
  border-color: #2f3299 !important;
}

.premiumDatePickerIcon {
  width: 18px !important;
  height: 18px !important;
  fill: none !important;
  stroke: #5e3a24 !important;
  stroke-width: 2 !important;
  margin-right: 6px !important;
}

.premiumDatePickerTextGroup {
  display: flex !important;
  flex-direction: column !important;
  flex-grow: 1 !important;
  min-width: 0 !important;
}

.premiumDatePickerMiniLabel {
  font-size: 9px !important;
  font-weight: 700 !important;
  color: #4a5568 !important;
  text-transform: uppercase !important;
  margin-bottom: 1px !important;
  text-align: left !important;
}

.premiumDatePickerValue {
  font-size: 11.5px !important;
  font-weight: 500 !important;
  color: #2d3748 !important;
  text-align: left !important;
  white-space: nowrap !important;
}

.premiumDatePickerInput {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  opacity: 0 !important;
  cursor: pointer !important;
}

.premiumDatePickerCaret {
  width: 14px !important;
  height: 14px !important;
  fill: none !important;
  stroke: #4a5568 !important;
  stroke-width: 2.5 !important;
  stroke-linecap: round !important;
  stroke-linejoin: round !important;
}

/* ==========================================================================
   PREMIUM MOBILE & TABLET RESPONSIVENESS AND DYNAMIC DRAWER SIDEBAR SYSTEM
   ========================================================================== */

/* Hamburger menu button for sidebar trigger */
.sidebar-toggle-btn {
  display: none;
  background: transparent;
  border: none;
  color: #2f3299;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.sidebar-toggle-btn:hover {
  background-color: #f0f2ff;
}

.sidebar-toggle-btn svg {
  stroke: #2f3299;
}

/* Translucent overlay for mobile sidebar */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(4px);
  z-index: 1000000;
  animation: fadeIn 0.25s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Responsive screen optimizations (< 991px) */
@media (max-width: 991px) {
  .sidebar-toggle-btn {
    display: flex;
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100dvh !important;
    height: 100vh;
    overflow: hidden !important;
    z-index: 1000010;
    transform: translateX(-100%);
    box-shadow: 10px 0 30px rgba(0, 0, 0, 0.15);
    transition: transform 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .sidebarLogoContainer {
    padding: 15px 10px 10px !important;
  }

  .sidebarLogoBg {
    width: 60px !important;
    height: 60px !important;
    margin-bottom: 6px !important;
  }

  .sidebarLogoBg img {
    width: 45px !important;
  }

  .sidebarLogoContainer h1 {
    font-size: 16px !important;
    margin-bottom: 2px !important;
  }

  .sidebarLogoContainer p {
    font-size: 9px !important;
    margin-bottom: 0 !important;
  }

  .sidebarNav {
    overflow-y: auto !important;
  }

  .mainLayoutWrapper.sidebar-open .sidebar {
    transform: translateX(0);
  }

  .sidebarNavItem {
    padding: 10px 16px !important;
    margin-left: 12px !important;
    border-radius: 20px 0 0 20px !important;
  }

  .sidebarNavItem .navIcon {
    margin-right: 10px !important;
  }

  .sidebarNavItem .navIcon svg {
    width: 18px !important;
    height: 18px !important;
  }

  .sidebarNavItem .navText {
    font-size: 14px !important;
  }

  .sidebarActiveIndicator {
    border-radius: 20px 0 0 20px !important;
  }

  .sidebarFooter {
    padding: 15px !important;
  }

  .logoutBtn {
    padding: 8px 16px !important;
    font-size: 13px !important;
    border-radius: 16px !important;
  }

  .mainLayoutRight {
    width: 100% !important;
  }

  .mainHeaderWrapper {
    padding: 12px 16px;
    gap: 12px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);
  }

  .headerSearch {
    width: 100% !important;
    max-width: 100%;
    margin-right: 0;
  }

  .mainContentArea {
    padding: 0 16px 20px !important;
  }
}

/* Responsive screen optimizations (< 768px) */
@media (max-width: 768px) {
  /* Grid & Forms */
  .premiumFormGrid {
    grid-template-columns: 1fr !important;
    gap: 16px !important;
  }

  .premiumFormCard {
    padding: 20px 16px !important;
    border-radius: 12px !important;
    margin-bottom: 20px !important;
  }

  /* Date / Time picker rows */
  .premiumTimePickersRow {
    flex-direction: column !important;
    height: auto !important;
    gap: 12px !important;
  }

  .premiumTimePickerWrapper {
    min-height: 52px !important;
    height: auto !important;
    padding: 8px 16px !important;
  }

  .premiumDatePickerTextGroup {
    text-align: left !important;
  }

  /* Make sure tables have solid swipeable overflow scroll */
  .tableWrapper,
  .table-responsive {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    margin-bottom: 15px;
  }

  /* Custom Search wrapper lists */
  .searchWrapper {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
    width: 100% !important;
  }

  .searchWrapper > div,
  .searchWrapper > button {
    width: 100% !important;
    justify-content: space-between !important;
  }

  .searchBox {
    width: 100% !important;
  }

  .searchBox > input {
    width: 100% !important;
  }

  /* Mine status hidden on very small header to avoid overlay overlap */
  .headerRight {
    gap: 12px !important;
  }

  .mineStatus {
    display: none !important;
  }

  /* Premium Filter Bar responsiveness */
  .premiumFilterBar {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px !important;
    width: 100% !important;
  }

  .premiumFilterLeft {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    width: 100% !important;
    gap: 10px !important;
  }

  .premiumFilterDropdown,
  .premiumFilterToggle,
  .premiumResetBtn {
    width: 100% !important;
    max-width: 100% !important;
  }

  .premiumFilterLeft .premiumDatePickerWrapper {
    width: calc(50% - 5px) !important;
    max-width: calc(50% - 5px) !important;
    display: inline-flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
  }

  .premiumFilterRight {
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
    width: 100% !important;
    gap: 12px !important;
    margin-top: 6px !important;
  }

  .premiumFilterRight .paginationContainer {
    margin-top: 0 !important;
    padding: 0 !important;
    margin-bottom: 0 !important;
  }

  .premiumFilterRight .premiumExportDropdown,
  .premiumFilterRight .premiumExportToggle {
    width: auto !important;
  }

  /* Scaling down buttons, typography, and SVGs on tablets/mobiles */
  .premiumBtnCancel,
  .premiumBtnSubmit {
    height: 40px !important;
    min-width: 120px !important;
    font-size: 14px !important;
    border-radius: 8px !important;
  }

  .premiumFilterToggle,
  .premiumDatePickerWrapper,
  .premiumExportToggle,
  .premiumResetBtn {
    height: 36px !important;
    font-size: 13px !important;
    padding: 6px 12px !important;
  }

  /* Shrinking SVGs */
  .premiumFilterCaret,
  .premiumDatePickerCaret {
    width: 12px !important;
    height: 12px !important;
    margin-left: 8px !important;
  }

  .premiumCalendarIcon {
    width: 15px !important;
    height: 15px !important;
    margin-right: 6px !important;
  }

  .premiumDatePickerIcon {
    width: 16px !important;
    height: 16px !important;
    margin-right: 8px !important;
  }

  /* Scaling down Headings and text sizes */
  .blueHeading,
  .premiumFormHeader h2 {
    font-size: 18px !important;
  }

  .premiumDatePickerMiniLabel {
    font-size: 9px !important;
  }

  .premiumDatePickerValue {
    font-size: 12px !important;
  }
}

/* Extra small devices (< 480px) */
@media (max-width: 480px) {
  .mainHeaderWrapper {
    flex-wrap: nowrap !important;
    padding: 10px 12px !important;
    gap: 8px !important;
  }

  .mainHeaderWrapper > div:first-child {
    min-width: 0 !important;
    gap: 8px !important;
  }

  .headerSearch {
    padding: 6px 10px !important;
    height: 36px !important;
    border-radius: 8px !important;
    min-width: 0 !important;
  }

  .headerSearch input {
    font-size: 12px !important;
    min-width: 0 !important;
  }

  .headerSearch .searchIcon svg {
    width: 14px !important;
    height: 14px !important;
  }

  .headerRight {
    width: auto !important;
    justify-content: flex-end !important;
    margin-top: 0 !important;
    border-top: none !important;
    padding-top: 0 !important;
    gap: 8px !important;
    flex-shrink: 0 !important;
  }

  .notificationIcon {
    width: 32px !important;
    height: 32px !important;
  }

  .notificationIcon svg {
    width: 32px !important;
    height: 32px !important;
  }

  .notificationBadge {
    width: 14px !important;
    height: 14px !important;
    font-size: 8px !important;
    top: -3px !important;
    right: -3px !important;
  }

  .profileIcon svg {
    width: 32px !important;
    height: 32px !important;
  }

  .premiumButtonsWrapper {
    flex-direction: column !important;
    gap: 10px !important;
    width: 100% !important;
  }

  /* Ultra compact buttons on mobile */
  .premiumBtnCancel,
  .premiumBtnSubmit {
    width: 100% !important;
    min-width: 100% !important;
    height: 36px !important;
    font-size: 12px !important;
    border-radius: 6px !important;
  }

  .logoutPopupDialog .modal-content {
    border-radius: 16px !important;
    padding: 24px 16px !important;
    max-width: 320px !important;
    margin: auto !important;
  }

  .logoutPopupTitle {
    font-size: 18px !important;
    margin-bottom: 8px !important;
  }

  .logoutPopupText {
    font-size: 13px !important;
    margin-bottom: 20px !important;
  }

  .logoutPopupButtons {
    flex-direction: row !important;
    gap: 12px !important;
  }

  .logoutPopupBtnCancel,
  .logoutPopupBtnConfirm {
    height: 38px !important;
    font-size: 14px !important;
    border-radius: 8px !important;
    max-width: none !important;
    flex: 1 1 !important;
  }

  /* Pagination tuning for ultra small mobile viewports like 375px */
  .premiumPaginationWrapper {
    gap: 6px !important;
  }

  .premiumPaginationText {
    font-size: 13px !important;
  }

  .premiumPaginationInput {
    width: 42px !important;
    height: 32px !important;
    font-size: 14px !important;
  }

  .premiumPaginationBtn {
    width: 32px !important;
    height: 32px !important;
  }

  /* Ultra compact typography and icons for mobile screens (< 480px) */
  .blueHeading,
  .premiumFormHeader h2 {
    font-size: 16px !important;
  }

  .premiumDatePickerMiniLabel {
    font-size: 8px !important;
  }

  .premiumDatePickerValue {
    font-size: 11px !important;
  }
  .premiumReportBtn {
    height: 40px !important;
    font-size: 13px !important;
    padding: 6px 14px !important;
  }
  .premiumReportBtn svg {
    width: 14px !important;
    height: 14px !important;
  }
}

/* Custom sizing overrides for ultra small devices under 380px width */
@media (max-width: 380px) {
  .notificationIcon {
    width: 32px !important;
    height: 32px !important;
    border-width: 1.5px !important;
  }

  .notificationIcon svg {
    width: 32px !important;
    height: 32px !important;
  }

  .notificationBadge {
    width: 15px !important;
    height: 15px !important;
    font-size: 8px !important;
    top: -4px !important;
    right: -4px !important;
  }

  .profileIcon svg {
    width: 32px !important;
    height: 32px !important;
  }
}

/* Global Premium Report Button utility classes */
.premiumReportBtn {
  border: none;
  border-radius: 8px;
  height: 46px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #ffffff !important;
  transition: all 0.2s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.premiumReportBtn:hover {
  transform: translateY(-1.5px);
  filter: brightness(1.05);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.12);
}

.premiumReportBtn:active {
  transform: translateY(0);
}

@media (max-width: 480px) {
  .premiumReportBtn {
    width: 100% !important;
    height: 36px !important;
    font-size: 12px !important;
    justify-content: center !important;
  }
}

/* Premium Modal Popup Styles */
.premiumModalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999 !important;
  animation: premiumFadeIn 0.3s ease-out;
}

.premiumModalContent {
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);
  width: 90%;
  max-width: 720px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: 10px 10px;
  animation: premiumSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.premiumModalCloseBtn {
  position: absolute;
  top: 24px;
  right: 24px;
  background: #f1f3f9;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 1;
  color: #718096;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  z-index: 10;
}

.premiumModalCloseBtn:hover {
  background-color: #e2e8f0;
  color: #1a202c;
  transform: rotate(90deg);
}

@keyframes premiumFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes premiumSlideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Adjustments for the forms inside modal */
.premiumFormCard {
  border: 1.5px solid #a2aed6 !important;
  box-shadow: 0px 8px 30px rgba(47, 50, 153, 0.08) !important;
}
.premiumFormCard:hover {
  border-color: #2f3299 !important;
  box-shadow: 0px 10px 35px rgba(47, 50, 153, 0.12) !important;
}
.premiumModalContent .premiumFormContainer {
  max-width: 100%;
  padding: 10px 20px;
}

.premiumModalContent .premiumFormCard {
  /* box-shadow: none !important;
  border: none !important; */
  padding: 16px 8px !important;
  margin-bottom: 16px !important;
}

.premiumModalContent .premiumButtonsWrapper {
  margin-top: 10px;
  margin-bottom: 16px;
}

/* ==========================================================================
   GLOBAL OFFLINE SCREEN STYLES
   ========================================================================== */
.offlineWrapper {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 999999 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: radial-gradient(circle, rgba(20, 24, 46, 0.96) 0%, rgba(8, 10, 21, 0.99) 100%) !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  animation: offlineFadeIn 0.35s ease-out !important;
}

.offlineCard {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 24px !important;
  padding: 48px 32px !important;
  max-width: 440px !important;
  width: 90% !important;
  text-align: center !important;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45) !important;
  animation: offlineCardPop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
}

.offlineRadarGroup {
  position: relative !important;
  width: 120px !important;
  height: 120px !important;
  margin: 0 auto 28px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.offlineRadarRing {
  position: absolute !important;
  border: 1.5px solid rgba(162, 174, 214, 0.15) !important;
  border-radius: 50% !important;
  animation: radarPulse 2s infinite linear !important;
}

.offlineRadarRing.ring-1 {
  width: 120px !important;
  height: 120px !important;
  animation-delay: 0s !important;
}

.offlineRadarRing.ring-2 {
  width: 90px !important;
  height: 90px !important;
  animation-delay: 0.6s !important;
}

.offlineIconWrapper {
  width: 60px !important;
  height: 60px !important;
  border-radius: 50% !important;
  background: rgba(255, 255, 255, 0.04) !important;
  border: 1.5px solid rgba(255, 255, 255, 0.1) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 2 !important;
}

.offlineIcon {
  width: 32px !important;
  height: 32px !important;
  fill: none !important;
  stroke: #c5cbe9 !important;
  stroke-width: 2 !important;
  stroke-linecap: round !important;
}

.offlineSlash {
  stroke: #ff4b4b !important;
  stroke-width: 2.5 !important;
  filter: drop-shadow(0 0 4px rgba(255, 75, 75, 0.6)) !important;
}

.offlineTitle {
  font-size: 26px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  margin-bottom: 12px !important;
  letter-spacing: -0.5px !important;
}

.offlineSubtitle {
  font-size: 14.5px !important;
  color: #a0aec0 !important;
  line-height: 1.6 !important;
  margin-bottom: 32px !important;
  padding: 0 10px !important;
}

.offlineErrorBadge {
  background: rgba(255, 75, 75, 0.1) !important;
  border: 1px solid rgba(255, 75, 75, 0.25) !important;
  color: #ff5c5c !important;
  font-size: 12.5px !important;
  font-weight: 600 !important;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  margin-bottom: 24px !important;
  display: inline-block !important;
  animation: offlineShake 0.4s ease-in-out !important;
}

.offlineRetryBtn {
  width: 100% !important;
  height: 48px !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #3f47d4 0%, #2f3299 100%) !important;
  color: #ffffff !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  border: none !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 4px 15px rgba(47, 50, 153, 0.3) !important;
}

.offlineRetryBtn:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(47, 50, 153, 0.5) !important;
  background: linear-gradient(135deg, #4d56e6 0%, #3a3db3 100%) !important;
}

.offlineRetryBtn:active:not(:disabled) {
  transform: translateY(0) !important;
}

.offlineRetryBtn:disabled {
  opacity: 0.8 !important;
  cursor: not-allowed !important;
}

/* Spinner for Loading State */
.offlineSpinner {
  width: 18px !important;
  height: 18px !important;
  animation: offlineRotate 1s linear infinite !important;
}

.offlineSpinner circle {
  stroke: #ffffff !important;
  stroke-linecap: round !important;
  animation: offlineDash 1.5s ease-in-out infinite !important;
}

/* Animations */
@keyframes offlineFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes offlineCardPop {
  from {
    transform: scale(0.9) translateY(20px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

@keyframes radarPulse {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  100% {
    transform: scale(1.1);
    opacity: 0;
  }
}

@keyframes offlineRotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes offlineDash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

@keyframes offlineShake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}

/* Custom Overrides: White background for Action Column on Assignment Page only */
@media (min-width: 1000px) {
  .assignmentTableWrapper td.row-fix-to-last,
  .assignmentTableWrapper tr.skyBlueTrBg td.row-fix-to-last {
    background-color: #ffffff !important;
  }
}

/* Responsive Grid layout for settings page buttons on mobile */
@media (max-width: 768px) {
  .settingsBtnContainer {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 10px !important;
    width: 100% !important;
  }

  .settingsBtnContainer .borderButton,
  .settingsBtnContainer .activeBorderButton,
  .settingsBtnContainer .premiumReportBtn {
    width: 100% !important;
    min-width: 0 !important;
    height: 38px !important;
    font-size: 12px !important;
    padding: 0 8px !important;
    justify-content: center !important;
    gap: 4px !important;
  }

  .settingsBtnContainer .borderButton svg,
  .settingsBtnContainer .activeBorderButton svg,
  .settingsBtnContainer .premiumReportBtn svg {
    width: 14px !important;
    height: 14px !important;
  }

  /* Compact Action buttons in tables on mobile */
  td.row-fix-to-last {
    gap: 6px !important;
    padding: 6px 4px !important;
  }

  td.row-fix-to-last button,
  td.row-fix-to-last .colorBtn {
    padding: 4px 8px !important;
    font-size: 11px !important;
    height: auto !important;
    min-height: 0 !important;
    line-height: normal !important;
    width: auto !important;
    border-radius: 4px !important;
  }

  /* Premium Modal Container adjustments */
  .premiumModalContent {
    width: 95% !important;
    max-width: 95vw !important;
    max-height: 92vh !important;
    padding: 12px 8px !important;
    border-radius: 12px !important;
  }

  .premiumModalCloseBtn {
    top: 14px !important;
    right: 14px !important;
    width: 28px !important;
    height: 28px !important;
    font-size: 16px !important;
  }

  .premiumModalContent .premiumFormContainer {
    padding: 0 4px !important;
  }

  .premiumModalContent .premiumFormHeader {
    margin-top: 4px !important;
    margin-bottom: 12px !important;
    padding-right: 28px !important;
  }

  .premiumModalContent .premiumFormHeader h2 {
    font-size: 16px !important;
    gap: 8px !important;
  }

  .premiumModalContent .premiumFormHeader h2 svg {
    width: 20px !important;
    height: 20px !important;
  }

  .premiumModalContent .premiumFormHeader p {
    font-size: 11px !important;
    margin-bottom: 0 !important;
  }

  .premiumModalContent .premiumFormCard {
    padding: 10px 8px !important;
    border-radius: 8px !important;
    margin-bottom: 12px !important;
  }

  /* Form Labels & Fields Row Height */
  .premiumModalContent .premiumFieldLabel,
  .premiumModalContent .inputBoxWrapper label,
  .custom-modal-container .inputBoxWrapper label {
    font-size: 12.5px !important;
    margin-bottom: 4px !important;
  }

  .premiumModalContent .premiumFormGrid,
  .custom-modal-container .custom-grid-2 {
    gap: 10px !important;
  }

  /* Text inputs, number inputs, selects, textareas scaling */
  .premiumModalContent .inputBoxWrapper input,
  .premiumModalContent .premiumInput,
  .custom-modal-container .inputBoxWrapper input {
    height: 36px !important;
    font-size: 13px !important;
    padding: 0 10px !important;
    border-radius: 6px !important;
  }

  .premiumModalContent .inputBoxWrapper textarea,
  .custom-modal-container .inputBoxWrapper textarea {
    font-size: 13px !important;
    padding: 8px 10px !important;
    border-radius: 6px !important;
    min-height: 70px !important;
  }

  /* React Select responsive size override inside modals */
  .premiumModalContent [class*="-control"],
  .custom-modal-container [class*="-control"] {
    min-height: 36px !important;
    height: auto !important;
    border-radius: 6px !important;
  }

  .premiumModalContent [class*="-ValueContainer"],
  .custom-modal-container [class*="-ValueContainer"] {
    padding: 2px 6px !important;
  }

  .premiumModalContent [class*="-placeholder"],
  .premiumModalContent [class*="-singleValue"],
  .custom-modal-container [class*="-placeholder"],
  .custom-modal-container [class*="-singleValue"] {
    font-size: 13px !important;
  }

  /* Custom Time Picker responsive scaling */
  .premiumModalContent .premiumTimePickerWrapper {
    height: 36px !important;
    padding: 0 8px !important;
    border-radius: 6px !important;
  }

  .premiumModalContent .premiumTimePickerLabel {
    font-size: 12.5px !important;
  }

  .premiumModalContent .premiumTimePickerCaret {
    width: 12px !important;
    height: 12px !important;
  }

  .premiumModalContent .premiumTimePickerWrapper svg {
    width: 14px !important;
    height: 14px !important;
  }

  /* Custom Date Picker responsive scaling */
  .premiumModalContent .premiumDatePickerWrapper {
    height: 36px !important;
    padding: 0 8px !important;
    border-radius: 6px !important;
  }

  .premiumModalContent .premiumDatePickerMiniLabel {
    font-size: 10px !important;
  }

  .premiumModalContent .premiumDatePickerValue {
    font-size: 12.5px !important;
  }

  .premiumModalContent .premiumDatePickerCaret {
    width: 12px !important;
    height: 12px !important;
  }

  .premiumModalContent .premiumDatePickerWrapper svg {
    width: 14px !important;
    height: 14px !important;
  }

  /* Submit & Cancel Buttons */
  .premiumModalContent .premiumBtnCancel,
  .premiumModalContent .premiumBtnSubmit {
    height: 36px !important;
    font-size: 12.5px !important;
    border-radius: 6px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB;AACF;AACA;;AAEA;EACE,SAAS;EACT,4CAA4C;EAC5C,mCAAmC;EACnC,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;;;;EAOE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA,yBAAyB;;AAEzB,iDAAiD;AACjD;EACE,iDAAiD;AACnD;;AAEA,wBAAwB;;AAExB,6EAA6E;AAC7E;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA,kBAAkB;;AAElB,oDAAoD;AACpD;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,8BAA8B;;AAE9B,uDAAuD;AACvD;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;oDAEkD;AACpD;;AAEA,0BAA0B;;AAE1B,wDAAwD;AACxD;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;AACA,sBAAsB;;AAEtB,qDAAqD;AACrD;EACE,iCAAiC;EACjC,uBAAuB;EACvB;;qDAEmD;EACnD,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA,oDAAoD;AACpD;EACE,YAAY;AACd;AACA;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,sCAAsC;EACtC,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;EAGE,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;IACV,sBAAsB;IACtB,0DAA0D;IAC1D,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,2DAA2D;EAC7D;;EAEA;IACE,oCAAoC;IACpC,yDAAyD;EAC3D;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf;;gCAE8B;EAC9B,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B;;gCAE8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC,EAAE,iBAAiB;AACzD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC,EAAE,oBAAoB;AAC5D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;AACA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,2CAA2C;EAC3C,yDAAiS;EACjS,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B;;oBAEkB;EAClB,UAAU;EACV,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oFAAoF;EACpF,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;EACpC,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,kBAAkB,EAAE,gCAAgC;EACpD,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf;;gBAEc;AAChB;;AAEA,uDAAuD;AACvD;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iCAAiC;AACjC;;EAEE,wBAAwB,EAAE,iCAAiC;AAC7D;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,gCAAgC;EAChC,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,wDAAwD;EACxD,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wDAAwD;EACxD,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gDAAgD;EAChD,mBAAmB;EACnB;;wBAEsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb;;+BAE6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf;;+BAE6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB;;0CAEwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,oBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;EACpC,sCAAsC;EACtC,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,oBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,uBAAuB;EACvB,sCAAsC;EACtC,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;;+EAE+E;;AAE/E,8CAA8C;AAC9C;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,4BAA4B;IAC5B,2CAA2C;IAC3C,4DAA4D;EAC9D;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;IAC5B,uCAAuC;EACzC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,4CAA4C;EAC9C;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA,4BAA4B;EAC5B;IACE,iCAAiC;IACjC,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,0DAA0D;EAC1D;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,4CAA4C;IAC5C,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,gCAAgC;EAChC;IACE,iCAAiC;IACjC,kCAAkC;IAClC,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,qEAAqE;EACrE;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,sCAAsC;EACtC;IACE,iCAAiC;IACjC,+BAA+B;IAC/B,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;IAC1B,8BAA8B;IAC9B,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;IAGE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,iCAAiC;IACjC,qCAAqC;IACrC,+BAA+B;IAC/B,8BAA8B;IAC9B,yCAAyC;IACzC,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,yCAAyC;IACzC,8BAA8B;IAC9B,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA,kEAAkE;EAClE;;IAEE,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;;;IAIE,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA,mBAAmB;EACnB;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA,yCAAyC;EACzC;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA,oCAAoC;EACpC;;IAEE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;;IAEE,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;IAC7B,0BAA0B;IAC1B,oBAAkB;EACpB;;EAEA,kEAAkE;EAClE;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,oEAAoE;EACpE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,kCAAkC;EACpC;AACF;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mDAAmD;EACnD,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,2CAA2C;AAC3C;EACE,sCAAsC;EACtC,2DAA2D;AAC7D;AACA;EACE,gCAAgC;EAChC,4DAA4D;AAC9D;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;4BAC0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,qGAAqG;EACrG,sCAAsC;EACtC,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,gDAAgD;EAChD,sDAAsD;EACtD,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,sDAAsD;EACtD,iFAAiF;AACnF;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,wDAAwD;EACxD,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,gDAAgD;EAChD,uDAAuD;EACvD,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,8DAA8D;AAChE;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,oDAAoD;EACpD,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,wEAAwE;EACxE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,6DAA6D;EAC7D,wDAAwD;AAC1D;;AAEA;EACE,sCAAsC;EACtC,wDAAwD;EACxD,wEAAwE;AAC1E;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,iFAAiF;AACjF;EACE;;IAEE,oCAAoC;EACtC;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,wBAAwB;IACxB,yCAAyC;IACzC,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;IAGE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;;;IAGE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,+CAA+C;EAC/C;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA,wCAAwC;EACxC;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA,oCAAoC;EACpC;;;IAGE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA,2DAA2D;EAC3D;;;IAGE,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA,wDAAwD;EACxD;;IAEE,2BAA2B;IAC3B,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA,0CAA0C;EAC1C;IACE,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,0CAA0C;EAC1C;IACE,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,4BAA4B;EAC5B;;IAEE,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap\");\n\n:root {\n  --background: #edf4ff !important;\n  --supportBlack: #303030 !important;\n  --light: #6a6969 !important;\n  --primary: #2f3293 !important;\n  --blue: #3a57e8 !important;\n  --lightBlue: #1890ff !important;\n  --supportRed: #ff4d4f !important;\n  --tableBg: #f7fbff !important;\n  --purple: #605bff !important;\n  --red: #ff3b30 !important;\n  --green: #34c759 !important\n;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Nunito\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--background) !important;\n}\n\ncode {\n  font-family: \"Nunito\", sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin-bottom: 0px !important;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n/* ----------React Select box Css ----------------- */\n.css-1u9des2-indicatorSeparator {\n  background-color: transparent !important;\n}\n\n.css-894a34-indicatorSeparator {\n  background-color: transparent !important;\n  color: black;\n}\n.css-olqui2-singleValue {\n  color: black !important;\n}\n\n.css-1vz0vyx-control {\n  background-color: rgb(238, 238, 238);\n  opacity: 70%;\n}\n\n/* -------------------- */\n\n/* --------------Comman Box Shadow ------------ */\n.comman-box-shadow {\n  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;\n}\n\n/* ------------------- */\n\n/* ------------------------Text Color Css --------------------------------- */\n.redColor {\n  color: var(--red) !important;\n  font-weight: 600;\n}\n.lightBlueColor {\n  color: var(--lightBlue) !important;\n  font-weight: 600;\n}\n\n.greenColor {\n  color: var(--green) !important;\n  font-weight: 600;\n}\n.yellowColor {\n  color: #faad14 !important;\n  font-weight: 600;\n}\n/* ------------- */\n\n/* -----------------table css -------------------- */\n.tableWrapper {\n  background-color: #ffffff;\n  width: 100%;\n  overflow: auto;\n  border: 1px solid var(--blue);\n  border-radius: 10px !important;\n  position: relative;\n}\n\n.tableWrapper > table {\n  width: 100%;\n  table-layout: auto;\n  border-radius: 10px !important;\n}\n\n.tableWrapper > table td {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.tableWrapper > table > thead {\n  width: 100%;\n}\n\n.tableWrapper > table > thead th {\n  height: 50px;\n  padding: 0px 12px;\n  background-color: var(--blue);\n  color: #fff;\n  font-weight: 500;\n  position: sticky;\n  top: 0px;\n  z-index: 12;\n}\n\n.tableWrapper > table > tbody td {\n  font-weight: 600;\n  padding: 10px 8px;\n}\n\n.skyBlueTrBg {\n  background-color: rgba(48, 176, 199, 0.1);\n}\n.whiteTrBg {\n  background-color: #ffffff;\n}\n\n.table_row_color {\n  background-color: #f7f6fe;\n}\n\n.col_80px {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.col_100px {\n  min-width: 100px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.col_120px {\n  min-width: 120px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_150px {\n  min-width: 150px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_190px {\n  min-width: 190px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.col_200px {\n  min-width: 200px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_220px {\n  min-width: 220px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_250px {\n  min-width: 250px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_300px {\n  min-width: 300px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_350px {\n  min-width: 350px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_400px {\n  min-width: 400px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/* ------------------------- */\n\n/* ------------------ Srollbar Css ------------------ */\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n  padding: 2px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: var(--blue);\n  border-radius: 10px;\n  height: 5px;\n  width: 5px;\n}\n\n::-webkit-scrollbar-track {\n  background: #e0e6eb;\n  width: 5px;\n  height: 5px;\n  padding: 2px;\n  box-shadow:\n    rgb(183, 197, 210) 3px 3px 6px 0px inset,\n    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;\n}\n\n/* --------------------- */\n\n/* ----------Page and card Wrapper Css --------------- */\n.pageWrapper {\n  margin: 20px 30px;\n}\n\n.cardWrapper {\n  padding: 24px;\n  margin: 24px;\n  border-radius: 10px;\n  background-color: #fff;\n}\n/* ----------------- */\n\n/* ---------------Tooltop Css --------------------- */\n.tooltip {\n  background-color: #fff !important;\n  color: black !important;\n  box-shadow:\n    rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\n    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px !important;\n  opacity: 100% !important;\n  padding: 14px !important;\n}\n\n/* -----------Spreadsheet__data-viewer ----------- */\n.Spreadsheet__data-viewer {\n  color: black;\n}\n.Spreadsheet__cell,\n.Spreadsheet__header {\n  text-align: center !important;\n  font-size: 8px !important;\n  /* border: 1px solid red !important; */\n  width: 10px !important;\n  min-width: 10px !important;\n  max-height: auto !important;\n  height: 200px !important;\n  overflow: none;\n  text-wrap: wrap;\n}\n\n.Spreadsheet__header {\n  font-size: 8px !important;\n  width: 30px !important;\n  height: 20px !important;\n}\n\n.Spreadsheet__header,\n.Spreadsheet__data-viewer,\n.Spreadsheet__data-editor input {\n  padding: 0px !important;\n  margin: 0px !important;\n  width: 20px !important;\n}\n\n.form-check {\n  min-height: 0px !important;\n}\n@media (min-width: 1000px) {\n  .row-fix-to-last {\n    position: sticky !important;\n    right: 0px;\n    z-index: 10 !important;\n    box-shadow: -6px 0 15px rgba(47, 50, 153, 0.08) !important;\n    transition: all 0.3s ease;\n  }\n\n  th.row-fix-to-last {\n    position: sticky !important;\n    top: 0px !important;\n    right: 0px !important;\n    z-index: 20 !important;\n    background-color: #2f3299 !important;\n    color: #ffffff !important;\n    font-weight: 700 !important;\n    text-align: center !important;\n    border-left: 1px solid rgba(255, 255, 255, 0.15) !important;\n  }\n\n  td.row-fix-to-last {\n    background-color: #f0f3fc !important;\n    border-left: 1px solid rgba(47, 50, 153, 0.08) !important;\n  }\n\n  tr.skyBlueTrBg td.row-fix-to-last {\n    background-color: #e8ebf8 !important;\n  }\n}\n\n/* Premium Action Pill Buttons */\n.premiumActionBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 6px 16px;\n  border-radius: 30px;\n  border: none;\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff !important;\n  cursor: pointer;\n  box-shadow:\n    0 4px 6px rgba(0, 0, 0, 0.06),\n    0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease-in-out;\n  text-decoration: none !important;\n}\n\n.premiumActionBtn:hover {\n  transform: translateY(-1.5px);\n  box-shadow:\n    0 6px 12px rgba(0, 0, 0, 0.1),\n    0 4px 6px rgba(0, 0, 0, 0.1);\n  color: #ffffff !important;\n}\n\n.premiumActionBtn:active {\n  transform: translateY(0);\n}\n\n.premiumActionBtn.edit {\n  background-color: #278e3c !important; /* Forest green */\n}\n\n.premiumActionBtn.edit:hover {\n  background-color: #1e702e !important;\n}\n\n.premiumActionBtn.view {\n  background-color: #2f3299 !important; /* Deep brand blue */\n}\n\n.premiumActionBtn.view:hover {\n  background-color: #242678 !important;\n}\n\n.premiumActionBtn svg {\n  width: 14px;\n  height: 14px;\n  fill: none !important;\n}\n\n.premiumActionBtn.edit svg,\n.premiumActionBtn.view svg {\n  stroke: #ffffff !important;\n}\n@media (max-width: 1000px) {\n  .tableWrapper > table > thead th {\n    height: 42px;\n    font-size: 14px;\n  }\n  .tableWrapper > table > tbody td {\n    font-weight: 600;\n    padding: 8px 8px;\n    font-size: 14px;\n  }\n}\n@media (max-width: 750px) {\n  .tableWrapper > table > thead th {\n    height: 34px;\n    font-size: 12px;\n  }\n  .error-message {\n    font-size: 12px;\n  }\n\n  .col_100px {\n    width: 60px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .col_150px {\n    width: 100px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .col_200px {\n    width: 120px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .col_250px {\n    width: 170px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .col_300px {\n    width: 220px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .col_350px {\n    width: 280px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .col_400px {\n    width: 320px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  .tableWrapper > table > tbody td {\n    font-weight: 600;\n    font-size: 12px;\n  }\n  .tableWrapper > table > tbody td svg {\n    width: 24px;\n    height: 24px;\n  }\n  .cardWrapper {\n    padding: 10px;\n    margin: 10px;\n    border-radius: 10px;\n    background-color: #fff;\n  }\n\n  .css-84ol4x-control {\n    height: 44px !important;\n    font-size: 14px;\n  }\n}\n\n/* --------- Premium Select Box ------------- */\n.premium-select-mine {\n  appearance: none;\n  background-color: #f9fafb;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 8px 32px 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n}\n\n.premium-select-mine:hover {\n  border-color: #9ca3af;\n  background-color: #ffffff;\n}\n\n.premium-select-mine:focus {\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n  background-color: #ffffff;\n}\n\n/* --------- New Layout Styles ------------- */\n.mainLayoutWrapper {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  background-color: #ffffff;\n  overflow: hidden;\n}\n\n/* Sidebar */\n.sidebar {\n  width: 280px;\n  background-color: #2f3299;\n  display: flex;\n  flex-direction: column;\n  color: white;\n  height: 100%;\n  flex-shrink: 0;\n}\n\n.sidebarLogoContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px 20px 20px;\n  cursor: pointer;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.sidebarLogoBg {\n  background-color: white;\n  border-radius: 50%;\n  width: 80px;\n  height: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.sidebarLogoBg img {\n  width: 60px;\n}\n\n.sidebarLogoContainer h1 {\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 1px;\n}\n\n.sidebarLogoContainer p {\n  font-size: 10px;\n}\n\n.sidebarNav {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  position: relative;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.sidebarNav::-webkit-scrollbar {\n  display: none;\n}\n\n.sidebarActiveIndicator {\n  /* margin-top: 15px; */\n  position: absolute;\n  top: 0;\n  left: 20px;\n  right: 0;\n  height: 56px;\n  background-color: #ffffff;\n  border-radius: 40px 0 0 40px;\n  transition:\n    transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1),\n    height 0.3s ease;\n  z-index: 0;\n  pointer-events: none;\n  border-color: transparent;\n}\n\n.sidebarActiveIndicator::before {\n  content: \"\";\n  position: absolute;\n  top: -40px;\n  right: -1px;\n  width: 40px;\n  height: 41px;\n  background: radial-gradient(circle at top left, transparent 40px, #ffffff 40.5px);\n  pointer-events: none;\n  border-color: transparent;\n}\n\n.sidebarActiveIndicator::after {\n  content: \"\";\n  position: absolute;\n  bottom: -40px;\n  right: -1px;\n  width: 40px;\n  height: 41px;\n  background: radial-gradient(circle at bottom left, transparent 40px, #ffffff 40.5px);\n  pointer-events: none;\n  border-color: transparent;\n}\n\n.sidebarNavItem {\n  display: flex;\n  align-items: center;\n  padding: 16px 20px;\n  cursor: pointer;\n  color: #fff;\n  transition: all 0.3s;\n  border-radius: 40px 0 0 40px;\n  margin-left: 20px;\n  position: relative;\n  z-index: 1;\n  border-color: transparent;\n}\n\n.sidebarNavItem .navIcon svg,\n.sidebarNavItem .navIcon svg path {\n  fill: #fff !important;\n  stroke: #fff !important;\n  transition: all 0.3s;\n}\n.sidebarNavItem .navIcon {\n  display: flex;\n  margin-right: 15px;\n}\n.sidebarNavItem .navIcon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.sidebarNavItem .navText {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.sidebarNavItem.active {\n  color: #2f3299;\n  font-weight: bold;\n}\n\n.sidebarNavItem.active .navIcon svg,\n.sidebarNavItem.active .navIcon svg path {\n  fill: #2f3299 !important;\n  stroke: #2f3299 !important;\n}\n\n.sidebarFooter {\n  padding: 20px;\n}\n\n.sidebarDivider {\n  height: 1px;\n  background-color: rgba(255, 255, 255, 0.2);\n  margin-bottom: 20px;\n}\n\n.logoutBtn {\n  background-color: white;\n  color: #ff4d4f;\n  border: none;\n  border-radius: 20px;\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.logoutBtn .logoutIcon svg path {\n  fill: #ff4d4f !important;\n}\n\n.logoutBtn:hover {\n  background-color: #ffe6e6;\n}\n\n/* Main Content Area */\n.mainLayoutRight {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n}\n\n/* Header */\n.mainHeaderWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 30px;\n  background-color: #ffff;\n  z-index: 10;\n}\n\n.headerSearch {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 10px 15px;\n  width: 100%;\n  max-width: 600px;\n  border: 1px solid #2f3299;\n  box-shadow: 0px 0px 12.89px 0px #56555540;\n}\n\n.headerSearch input {\n  border: none;\n  background: transparent;\n  outline: none;\n  flex: 1;\n  font-size: 14px;\n}\n\n.headerSearch .searchIcon {\n  color: #888;\n}\n\n.headerRight {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.mineStatus {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #fff;\n  padding: 4px 8px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #555;\n  border: 1px solid #4547a1;\n}\n.mineStatus span {\n  color: #4547a1;\n  font-weight: 500;\n}\n\n.statusDot {\n  width: 18px;\n  height: 18px;\n  background-color: #34c759;\n  border-radius: 50%;\n}\n\n.notificationIcon {\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  /* border: 2px solid #2f3299; */\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n}\n\n.notificationBadge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background-color: #ff4d4f;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.profileIcon {\n  cursor: pointer;\n}\n\n/* Page Content */\n.mainContentArea {\n  flex: 1;\n  padding: 0 30px 30px;\n  overflow-y: auto;\n  background-color: #ffff;\n}\n\n.pageWrapper {\n  margin: 0 !important;\n  background-color: #4547a11c;\n  border-radius: 10px;\n  padding: 5px 20px;\n}\n.pageWrapperWhite {\n  margin: 0 !important;\n  background-color: #ffffff;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.cardWrapper {\n  margin: 0 !important;\n}\n\n/* Modifying table styles for new theme */\n.tableWrapper > table > thead th {\n  background-color: #2f3299 !important;\n  color: #ffffff;\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.tableWrapper > table > tbody td {\n  border-bottom: 1px solid #eee;\n  border-right: 1px solid #eee;\n  background-color: #fff;\n}\n\n/* Pagination Styles */\n.paginationContainer {\n  font-family: \"Nunito\", sans-serif;\n}\n\n.prevNextBtn {\n  background-color: transparent;\n  border: 1px solid #ccc;\n  color: #555;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.prevNextBtn:hover:not(:disabled) {\n  background-color: #f0f0f0;\n}\n\n.prevNextBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pageNumberBtn {\n  background-color: transparent;\n  border: 1px solid #ccc;\n  color: #555;\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.pageNumberBtn:hover {\n  background-color: #f0f0f0;\n}\n\n.pageNumberBtn.active {\n  background-color: #2f3299;\n  color: white;\n  border-color: #2f3299;\n}\n\n/* New Premium Pagination styling matching the screenshot */\n.premiumPaginationWrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.premiumPaginationInput {\n  width: 48px;\n  height: 36px;\n  border: 1px solid #ccc;\n  background-color: #ffffff;\n  color: #1d1d1d;\n  font-size: 16px;\n  font-weight: bold;\n  text-align: center;\n  outline: none;\n  border-radius: 0px; /* Square as in the screenshot */\n  transition: border-color 0.2s;\n}\n\n.premiumPaginationInput:focus {\n  border-color: #2f3299;\n}\n\n/* Chrome, Safari, Edge, Opera: Remove spin arrows */\n.premiumPaginationInput::-webkit-outer-spin-button,\n.premiumPaginationInput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox: Remove spin arrows */\n.premiumPaginationInput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.premiumPaginationText {\n  color: #757575;\n  font-size: 16px;\n  font-weight: 500;\n  user-select: none;\n}\n\n.premiumPaginationBtn {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  transition:\n    background-color 0.2s,\n    opacity 0.2s;\n}\n\n/* Enabled Active Next/Prev Button (Dark Blue/Purple) */\n.premiumPaginationBtn.btnActive {\n  background-color: #2f3299;\n  color: #ffffff;\n}\n\n.premiumPaginationBtn.btnActive:hover {\n  background-color: #242678;\n}\n\n/* Disabled Faded Next/Prev Button (Light Purple/Blue) */\n.premiumPaginationBtn:disabled {\n  background-color: #a2aed6;\n  color: #ffffff;\n  cursor: not-allowed;\n}\n\n.premiumPaginationBtn svg {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2.5;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* Premium Filter Bar Layout matching screenshot */\n.premiumFilterBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  width: 100%;\n  margin-bottom: 20px;\n  background-color: transparent;\n}\n\n.premiumFilterLeft {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.premiumFilterRight {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* Dropdown Filters and Buttons */\n.premiumFilterDropdown .dropdown-toggle::after,\n.premiumExportDropdown .dropdown-toggle::after {\n  display: none !important; /* Hide bootstrap default caret */\n}\n\n.premiumFilterToggle,\n.premiumDatePickerWrapper,\n.premiumExportToggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #ffffff !important;\n  border: 1.5px solid #dcdcdc;\n  border-radius: 8px;\n  padding: 8px 16px;\n  color: #2f3299 !important;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease-in-out;\n  height: 40px;\n  user-select: none;\n}\n\n.premiumDatePickerWrapper > svg:first-of-type {\n  width: 20px !important;\n  height: 18px !important;\n}\n\n.premiumFilterToggle {\n  min-width: 130px;\n}\n\n.premiumFilterToggle:hover,\n.premiumDatePickerWrapper:hover,\n.premiumExportToggle:hover {\n  border-color: #2f3299;\n  box-shadow: 0px 6px 14px rgba(47, 50, 153, 0.1);\n}\n\n.premiumFilterCaret,\n.premiumDatePickerCaret {\n  width: 14px;\n  height: 14px;\n  fill: none;\n  stroke: #2f3299;\n  stroke-width: 2.5;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  margin-left: 12px;\n}\n\n.premiumCalendarIcon {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: #2f3299;\n  stroke-width: 2;\n  margin-right: 10px;\n}\n\n/* Custom Checkbox dropdown list */\n.premiumFilterMenu {\n  border: none !important;\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15) !important;\n  border-radius: 8px !important;\n  padding: 8px 0 !important;\n  min-width: 180px !important;\n}\n\n.premiumFilterItem {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.premiumFilterItem:hover {\n  background-color: #f5f6ff;\n}\n\n.premiumFilterCheckbox {\n  cursor: pointer;\n  accent-color: #2f3299;\n  width: 16px;\n  height: 16px;\n}\n\n.premiumFilterItemLabel {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333333;\n}\n\n/* Invisible standard date picker cover */\n.premiumDatePickerWrapper {\n  position: relative;\n  min-width: 140px;\n  display: flex;\n  align-items: center;\n}\n\n.premiumDatePickerInput {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.premiumDatePickerLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2f3299;\n}\n\n/* Solid Reset button */\n.premiumResetBtn {\n  background-color: #2f3299;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 24px;\n  font-size: 15px;\n  font-weight: 600;\n  height: 40px;\n  white-space: nowrap;\n  cursor: pointer;\n  box-shadow: 0px 4px 12px rgba(47, 50, 153, 0.2);\n  transition: all 0.2s ease-in-out;\n}\n\n.premiumResetBtn:hover {\n  background-color: #21236b;\n  box-shadow: 0px 6px 16px rgba(47, 50, 153, 0.3);\n}\n\n/* Export dropdown specific styles */\n.premiumExportToggle {\n  border-color: #2f3299;\n  background-color: #ffffff;\n  color: #2f3299;\n  min-width: 110px;\n  box-shadow: 0px 4px 10px rgba(47, 50, 153, 0.08);\n}\n\n.premiumExportToggle:hover {\n  background-color: #2f3299;\n  color: #ffffff;\n}\n\n.premiumExportToggle:hover .premiumExportIcon {\n  stroke: #ffffff;\n}\n\n.premiumExportIcon {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: #2f3299;\n  stroke-width: 2.5;\n  margin-left: 10px;\n  transition: stroke 0.2s;\n}\n\n.premiumExportMenu {\n  border: none !important;\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15) !important;\n  border-radius: 8px !important;\n  padding: 8px 0 !important;\n  min-width: 150px !important;\n}\n\n.premiumExportMenu a {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4a5568 !important;\n  padding: 8px 16px !important;\n  transition: background-color 0.2s;\n}\n\n.premiumExportMenu a:hover {\n  background-color: #f5f6ff !important;\n  color: #2f3299 !important;\n}\n\n/* Premium Form Styling (Add Shift etc.) */\n.premiumFormContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 20px 0;\n}\n\n.premiumFormHeader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.premiumFormHeaderIcon {\n  width: 48px;\n  height: 48px;\n  background-color: #2f3299;\n  color: #ffffff;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  box-shadow: 0px 4px 12px rgba(47, 50, 153, 0.2);\n}\n\n.premiumFormHeaderIcon svg {\n  width: 24px;\n  height: 24px;\n  stroke: currentColor;\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n\n.premiumFormHeader h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #2f3299;\n  margin: 0 0 6px 0;\n}\n\n.premiumFormHeader p {\n  font-size: 14px;\n  color: #718096;\n  margin: 0;\n}\n\n.premiumFormCard {\n  background-color: #ffffff;\n  border: 1.5px solid #a2aed6;\n  border-radius: 16px;\n  padding: 32px;\n  width: 100%;\n  box-shadow: 0px 8px 30px rgba(47, 50, 153, 0.08);\n  margin-bottom: 32px;\n  transition:\n    border-color 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.premiumFormCard:hover {\n  border-color: #2f3299;\n  box-shadow: 0px 10px 35px rgba(47, 50, 153, 0.12);\n}\n\n.premiumFormGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.premiumFieldGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n.premiumFieldLabel {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.premiumInput {\n  height: 44px;\n  border: 1px solid #2f3293;\n  border-radius: 8px;\n  padding: 0 16px;\n  font-size: 15px;\n  color: #2d3748;\n  background-color: #ffffff;\n  outline: none;\n  transition:\n    border-color 0.2s ease-in-out,\n    box-shadow 0.2s ease-in-out;\n}\n\n.premiumInput:focus {\n  border-color: #2f3299;\n  box-shadow: 0px 0px 0px 3px rgba(47, 50, 153, 0.1);\n}\n\n.premiumInput:disabled {\n  border: 1px solid #2f3293;\n  color: #718096;\n  border-color: #2f3293;\n  cursor: not-allowed;\n}\n\n/* Custom Time Pickers row */\n.premiumTimePickersRow {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n}\n\n.premiumTimePickerWrapper {\n  position: relative;\n  flex: 1;\n  height: 44px;\n  border: 1.5px solid #a2aed6;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  background-color: #ffffff;\n  cursor: pointer;\n  transition:\n    border-color 0.2s ease-in-out,\n    box-shadow 0.2s ease-in-out;\n}\n\n.premiumTimePickerWrapper:hover {\n  border-color: #2f3299;\n}\n\n.premiumTimePickerInput {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.premiumTimePickerLabel {\n  font-size: 15px;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.premiumTimePickerCaret {\n  width: 14px;\n  height: 14px;\n  fill: none;\n  stroke: #4a5568;\n  stroke-width: 2.5;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.premiumTimePickerIcon {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: #2f3299;\n  stroke-width: 2;\n  margin-right: 10px;\n}\n\n/* Centered buttons at the bottom */\n.premiumButtonsWrapper {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  width: 100%;\n}\n\n.premiumBtnCancel {\n  height: 46px;\n  min-width: 160px;\n  background-color: #ffffff;\n  border: 1.5px solid #2f3299;\n  color: #2f3299;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  box-shadow: 0px 4px 10px rgba(47, 50, 153, 0.05);\n}\n\n.premiumBtnCancel:hover {\n  background-color: #f5f6ff;\n  box-shadow: 0px 6px 14px rgba(47, 50, 153, 0.1);\n}\n\n.premiumBtnSubmit {\n  height: 46px;\n  min-width: 160px;\n  background-color: #2f3299;\n  border: none;\n  color: #ffffff;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  box-shadow: 0px 4px 14px rgba(47, 50, 153, 0.2);\n}\n\n.premiumBtnSubmit:hover {\n  background-color: #21236b;\n  box-shadow: 0px 6px 18px rgba(47, 50, 153, 0.35);\n}\n\n/* Premium Form Card InputBox CSS overrides */\n.premiumFormCard .inputBoxWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.premiumFormCard .inputBoxWrapper label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 0;\n}\n\n.premiumFormCard .inputBoxWrapper input {\n  height: 44px !important;\n  border: 1.5px solid #a2aed6 !important;\n  border-radius: 8px !important;\n  padding: 0 16px !important;\n  font-size: 15px !important;\n  color: #2d3748 !important;\n  background-color: #ffffff !important;\n  outline: none !important;\n  transition:\n    border-color 0.2s ease-in-out,\n    box-shadow 0.2s ease-in-out !important;\n}\n\n.premiumFormCard .inputBoxWrapper input:focus {\n  border-color: #2f3299 !important;\n  box-shadow: 0px 0px 0px 3px rgba(47, 50, 153, 0.1) !important;\n}\n\n.premiumFormCard .inputBoxWrapper input:disabled {\n  background-color: #f7fafc !important;\n  color: #718096 !important;\n  border-color: #e2e8f0 !important;\n  cursor: not-allowed !important;\n  opacity: 1 !important;\n}\n\n/* Logout Custom Popup CSS */\n.logoutPopupDialog .modal-content {\n  border-radius: 24px !important;\n  border: none !important;\n  padding: 32px 24px !important;\n  text-align: center !important;\n  background-color: #ffffff !important;\n  max-width: 440px !important;\n  margin: auto !important;\n  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.12) !important;\n}\n\n.logoutPopupTitle {\n  font-size: 22px !important;\n  font-weight: 700 !important;\n  color: #000000 !important;\n  margin-bottom: 12px !important;\n  text-align: center !important;\n}\n\n.logoutPopupText {\n  font-size: 15px !important;\n  font-weight: 500 !important;\n  color: #718096 !important;\n  margin-bottom: 24px !important;\n  text-align: center !important;\n}\n\n.logoutPopupButtons {\n  display: flex !important;\n  justify-content: center !important;\n  gap: 16px !important;\n  width: 100% !important;\n}\n\n.logoutPopupBtnCancel {\n  height: 44px !important;\n  flex: 1 !important;\n  max-width: 140px !important;\n  background-color: #ffffff !important;\n  border: 1.5px solid #2f3299 !important;\n  color: #2f3299 !important;\n  border-radius: 12px !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease-in-out !important;\n}\n\n.logoutPopupBtnCancel:hover {\n  background-color: #f5f6ff !important;\n}\n\n.logoutPopupBtnConfirm {\n  height: 44px !important;\n  flex: 1 !important;\n  max-width: 140px !important;\n  background-color: #c90000 !important;\n  border: none !important;\n  color: #ffffff !important;\n  border-radius: 12px !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease-in-out !important;\n}\n\n.logoutPopupBtnConfirm:hover {\n  background-color: #a80000 !important;\n}\n\n/* Custom Premium Date Pickers */\n.premiumFilterBar .premiumDatePickerWrapper {\n  flex: none !important;\n  height: 40px !important;\n}\n\n.premiumDatePickerWrapper {\n  position: relative;\n  flex: 1;\n  height: 48px !important;\n  border: 1.5px solid #a2aed6 !important;\n  border-radius: 8px !important;\n  display: flex !important;\n  align-items: center !important;\n  padding: 0 8px !important;\n  background-color: #ffffff !important;\n  cursor: pointer !important;\n  transition: border-color 0.2s ease-in-out !important;\n}\n\n.premiumDatePickerWrapper:hover {\n  border-color: #2f3299 !important;\n}\n\n.premiumDatePickerIcon {\n  width: 18px !important;\n  height: 18px !important;\n  fill: none !important;\n  stroke: #5e3a24 !important;\n  stroke-width: 2 !important;\n  margin-right: 6px !important;\n}\n\n.premiumDatePickerTextGroup {\n  display: flex !important;\n  flex-direction: column !important;\n  flex-grow: 1 !important;\n  min-width: 0 !important;\n}\n\n.premiumDatePickerMiniLabel {\n  font-size: 9px !important;\n  font-weight: 700 !important;\n  color: #4a5568 !important;\n  text-transform: uppercase !important;\n  margin-bottom: 1px !important;\n  text-align: left !important;\n}\n\n.premiumDatePickerValue {\n  font-size: 11.5px !important;\n  font-weight: 500 !important;\n  color: #2d3748 !important;\n  text-align: left !important;\n  white-space: nowrap !important;\n}\n\n.premiumDatePickerInput {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  opacity: 0 !important;\n  cursor: pointer !important;\n}\n\n.premiumDatePickerCaret {\n  width: 14px !important;\n  height: 14px !important;\n  fill: none !important;\n  stroke: #4a5568 !important;\n  stroke-width: 2.5 !important;\n  stroke-linecap: round !important;\n  stroke-linejoin: round !important;\n}\n\n/* ==========================================================================\n   PREMIUM MOBILE & TABLET RESPONSIVENESS AND DYNAMIC DRAWER SIDEBAR SYSTEM\n   ========================================================================== */\n\n/* Hamburger menu button for sidebar trigger */\n.sidebar-toggle-btn {\n  display: none;\n  background: transparent;\n  border: none;\n  color: #2f3299;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.sidebar-toggle-btn:hover {\n  background-color: #f0f2ff;\n}\n\n.sidebar-toggle-btn svg {\n  stroke: #2f3299;\n}\n\n/* Translucent overlay for mobile sidebar */\n.sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(4px);\n  z-index: 1000000;\n  animation: fadeIn 0.25s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Responsive screen optimizations (< 991px) */\n@media (max-width: 991px) {\n  .sidebar-toggle-btn {\n    display: flex;\n  }\n\n  .sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100dvh !important;\n    height: 100vh;\n    overflow: hidden !important;\n    z-index: 1000010;\n    transform: translateX(-100%);\n    box-shadow: 10px 0 30px rgba(0, 0, 0, 0.15);\n    transition: transform 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);\n  }\n\n  .sidebarLogoContainer {\n    padding: 15px 10px 10px !important;\n  }\n\n  .sidebarLogoBg {\n    width: 60px !important;\n    height: 60px !important;\n    margin-bottom: 6px !important;\n  }\n\n  .sidebarLogoBg img {\n    width: 45px !important;\n  }\n\n  .sidebarLogoContainer h1 {\n    font-size: 16px !important;\n    margin-bottom: 2px !important;\n  }\n\n  .sidebarLogoContainer p {\n    font-size: 9px !important;\n    margin-bottom: 0 !important;\n  }\n\n  .sidebarNav {\n    overflow-y: auto !important;\n  }\n\n  .mainLayoutWrapper.sidebar-open .sidebar {\n    transform: translateX(0);\n  }\n\n  .sidebarNavItem {\n    padding: 10px 16px !important;\n    margin-left: 12px !important;\n    border-radius: 20px 0 0 20px !important;\n  }\n\n  .sidebarNavItem .navIcon {\n    margin-right: 10px !important;\n  }\n\n  .sidebarNavItem .navIcon svg {\n    width: 18px !important;\n    height: 18px !important;\n  }\n\n  .sidebarNavItem .navText {\n    font-size: 14px !important;\n  }\n\n  .sidebarActiveIndicator {\n    border-radius: 20px 0 0 20px !important;\n  }\n\n  .sidebarFooter {\n    padding: 15px !important;\n  }\n\n  .logoutBtn {\n    padding: 8px 16px !important;\n    font-size: 13px !important;\n    border-radius: 16px !important;\n  }\n\n  .mainLayoutRight {\n    width: 100% !important;\n  }\n\n  .mainHeaderWrapper {\n    padding: 12px 16px;\n    gap: 12px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);\n  }\n\n  .headerSearch {\n    width: 100% !important;\n    max-width: 100%;\n    margin-right: 0;\n  }\n\n  .mainContentArea {\n    padding: 0 16px 20px !important;\n  }\n}\n\n/* Responsive screen optimizations (< 768px) */\n@media (max-width: 768px) {\n  /* Grid & Forms */\n  .premiumFormGrid {\n    grid-template-columns: 1fr !important;\n    gap: 16px !important;\n  }\n\n  .premiumFormCard {\n    padding: 20px 16px !important;\n    border-radius: 12px !important;\n    margin-bottom: 20px !important;\n  }\n\n  /* Date / Time picker rows */\n  .premiumTimePickersRow {\n    flex-direction: column !important;\n    height: auto !important;\n    gap: 12px !important;\n  }\n\n  .premiumTimePickerWrapper {\n    min-height: 52px !important;\n    height: auto !important;\n    padding: 8px 16px !important;\n  }\n\n  .premiumDatePickerTextGroup {\n    text-align: left !important;\n  }\n\n  /* Make sure tables have solid swipeable overflow scroll */\n  .tableWrapper,\n  .table-responsive {\n    width: 100% !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    margin-bottom: 15px;\n  }\n\n  /* Custom Search wrapper lists */\n  .searchWrapper {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 12px !important;\n    width: 100% !important;\n  }\n\n  .searchWrapper > div,\n  .searchWrapper > button {\n    width: 100% !important;\n    justify-content: space-between !important;\n  }\n\n  .searchBox {\n    width: 100% !important;\n  }\n\n  .searchBox > input {\n    width: 100% !important;\n  }\n\n  /* Mine status hidden on very small header to avoid overlay overlap */\n  .headerRight {\n    gap: 12px !important;\n  }\n\n  .mineStatus {\n    display: none !important;\n  }\n\n  /* Premium Filter Bar responsiveness */\n  .premiumFilterBar {\n    flex-direction: column !important;\n    align-items: stretch !important;\n    gap: 12px !important;\n    width: 100% !important;\n  }\n\n  .premiumFilterLeft {\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: wrap !important;\n    align-items: center !important;\n    width: 100% !important;\n    gap: 10px !important;\n  }\n\n  .premiumFilterDropdown,\n  .premiumFilterToggle,\n  .premiumResetBtn {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  .premiumFilterLeft .premiumDatePickerWrapper {\n    width: calc(50% - 5px) !important;\n    max-width: calc(50% - 5px) !important;\n    display: inline-flex !important;\n    flex-direction: row !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n  }\n\n  .premiumFilterRight {\n    flex-direction: row !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    width: 100% !important;\n    gap: 12px !important;\n    margin-top: 6px !important;\n  }\n\n  .premiumFilterRight .paginationContainer {\n    margin-top: 0 !important;\n    padding: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .premiumFilterRight .premiumExportDropdown,\n  .premiumFilterRight .premiumExportToggle {\n    width: auto !important;\n  }\n\n  /* Scaling down buttons, typography, and SVGs on tablets/mobiles */\n  .premiumBtnCancel,\n  .premiumBtnSubmit {\n    height: 40px !important;\n    min-width: 120px !important;\n    font-size: 14px !important;\n    border-radius: 8px !important;\n  }\n\n  .premiumFilterToggle,\n  .premiumDatePickerWrapper,\n  .premiumExportToggle,\n  .premiumResetBtn {\n    height: 36px !important;\n    font-size: 13px !important;\n    padding: 6px 12px !important;\n  }\n\n  /* Shrinking SVGs */\n  .premiumFilterCaret,\n  .premiumDatePickerCaret {\n    width: 12px !important;\n    height: 12px !important;\n    margin-left: 8px !important;\n  }\n\n  .premiumCalendarIcon {\n    width: 15px !important;\n    height: 15px !important;\n    margin-right: 6px !important;\n  }\n\n  .premiumDatePickerIcon {\n    width: 16px !important;\n    height: 16px !important;\n    margin-right: 8px !important;\n  }\n\n  /* Scaling down Headings and text sizes */\n  .blueHeading,\n  .premiumFormHeader h2 {\n    font-size: 18px !important;\n  }\n\n  .premiumDatePickerMiniLabel {\n    font-size: 9px !important;\n  }\n\n  .premiumDatePickerValue {\n    font-size: 12px !important;\n  }\n}\n\n/* Extra small devices (< 480px) */\n@media (max-width: 480px) {\n  .mainHeaderWrapper {\n    flex-wrap: nowrap !important;\n    padding: 10px 12px !important;\n    gap: 8px !important;\n  }\n\n  .mainHeaderWrapper > div:first-child {\n    min-width: 0 !important;\n    gap: 8px !important;\n  }\n\n  .headerSearch {\n    padding: 6px 10px !important;\n    height: 36px !important;\n    border-radius: 8px !important;\n    min-width: 0 !important;\n  }\n\n  .headerSearch input {\n    font-size: 12px !important;\n    min-width: 0 !important;\n  }\n\n  .headerSearch .searchIcon svg {\n    width: 14px !important;\n    height: 14px !important;\n  }\n\n  .headerRight {\n    width: auto !important;\n    justify-content: flex-end !important;\n    margin-top: 0 !important;\n    border-top: none !important;\n    padding-top: 0 !important;\n    gap: 8px !important;\n    flex-shrink: 0 !important;\n  }\n\n  .notificationIcon {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  .notificationIcon svg {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  .notificationBadge {\n    width: 14px !important;\n    height: 14px !important;\n    font-size: 8px !important;\n    top: -3px !important;\n    right: -3px !important;\n  }\n\n  .profileIcon svg {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  .premiumButtonsWrapper {\n    flex-direction: column !important;\n    gap: 10px !important;\n    width: 100% !important;\n  }\n\n  /* Ultra compact buttons on mobile */\n  .premiumBtnCancel,\n  .premiumBtnSubmit {\n    width: 100% !important;\n    min-width: 100% !important;\n    height: 36px !important;\n    font-size: 12px !important;\n    border-radius: 6px !important;\n  }\n\n  .logoutPopupDialog .modal-content {\n    border-radius: 16px !important;\n    padding: 24px 16px !important;\n    max-width: 320px !important;\n    margin: auto !important;\n  }\n\n  .logoutPopupTitle {\n    font-size: 18px !important;\n    margin-bottom: 8px !important;\n  }\n\n  .logoutPopupText {\n    font-size: 13px !important;\n    margin-bottom: 20px !important;\n  }\n\n  .logoutPopupButtons {\n    flex-direction: row !important;\n    gap: 12px !important;\n  }\n\n  .logoutPopupBtnCancel,\n  .logoutPopupBtnConfirm {\n    height: 38px !important;\n    font-size: 14px !important;\n    border-radius: 8px !important;\n    max-width: none !important;\n    flex: 1 !important;\n  }\n\n  /* Pagination tuning for ultra small mobile viewports like 375px */\n  .premiumPaginationWrapper {\n    gap: 6px !important;\n  }\n\n  .premiumPaginationText {\n    font-size: 13px !important;\n  }\n\n  .premiumPaginationInput {\n    width: 42px !important;\n    height: 32px !important;\n    font-size: 14px !important;\n  }\n\n  .premiumPaginationBtn {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  /* Ultra compact typography and icons for mobile screens (< 480px) */\n  .blueHeading,\n  .premiumFormHeader h2 {\n    font-size: 16px !important;\n  }\n\n  .premiumDatePickerMiniLabel {\n    font-size: 8px !important;\n  }\n\n  .premiumDatePickerValue {\n    font-size: 11px !important;\n  }\n  .premiumReportBtn {\n    height: 40px !important;\n    font-size: 13px !important;\n    padding: 6px 14px !important;\n  }\n  .premiumReportBtn svg {\n    width: 14px !important;\n    height: 14px !important;\n  }\n}\n\n/* Custom sizing overrides for ultra small devices under 380px width */\n@media (max-width: 380px) {\n  .notificationIcon {\n    width: 32px !important;\n    height: 32px !important;\n    border-width: 1.5px !important;\n  }\n\n  .notificationIcon svg {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  .notificationBadge {\n    width: 15px !important;\n    height: 15px !important;\n    font-size: 8px !important;\n    top: -4px !important;\n    right: -4px !important;\n  }\n\n  .profileIcon svg {\n    width: 32px !important;\n    height: 32px !important;\n  }\n}\n\n/* Global Premium Report Button utility classes */\n.premiumReportBtn {\n  border: none;\n  border-radius: 8px;\n  height: 46px;\n  padding: 0 20px;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  color: #ffffff !important;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n}\n\n.premiumReportBtn:hover {\n  transform: translateY(-1.5px);\n  filter: brightness(1.05);\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.12);\n}\n\n.premiumReportBtn:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 480px) {\n  .premiumReportBtn {\n    width: 100% !important;\n    height: 36px !important;\n    font-size: 12px !important;\n    justify-content: center !important;\n  }\n}\n\n/* Premium Modal Popup Styles */\n.premiumModalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(5px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999999 !important;\n  animation: premiumFadeIn 0.3s ease-out;\n}\n\n.premiumModalContent {\n  background-color: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);\n  width: 90%;\n  max-width: 720px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  padding: 10px 10px;\n  animation: premiumSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.premiumModalCloseBtn {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  background: #f1f3f9;\n  border: none;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  font-size: 22px;\n  line-height: 1;\n  color: #718096;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease-in-out;\n  z-index: 10;\n}\n\n.premiumModalCloseBtn:hover {\n  background-color: #e2e8f0;\n  color: #1a202c;\n  transform: rotate(90deg);\n}\n\n@keyframes premiumFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes premiumSlideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Adjustments for the forms inside modal */\n.premiumFormCard {\n  border: 1.5px solid #a2aed6 !important;\n  box-shadow: 0px 8px 30px rgba(47, 50, 153, 0.08) !important;\n}\n.premiumFormCard:hover {\n  border-color: #2f3299 !important;\n  box-shadow: 0px 10px 35px rgba(47, 50, 153, 0.12) !important;\n}\n.premiumModalContent .premiumFormContainer {\n  max-width: 100%;\n  padding: 10px 20px;\n}\n\n.premiumModalContent .premiumFormCard {\n  /* box-shadow: none !important;\n  border: none !important; */\n  padding: 16px 8px !important;\n  margin-bottom: 16px !important;\n}\n\n.premiumModalContent .premiumButtonsWrapper {\n  margin-top: 10px;\n  margin-bottom: 16px;\n}\n\n/* ==========================================================================\n   GLOBAL OFFLINE SCREEN STYLES\n   ========================================================================== */\n.offlineWrapper {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  z-index: 999999 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background: radial-gradient(circle, rgba(20, 24, 46, 0.96) 0%, rgba(8, 10, 21, 0.99) 100%) !important;\n  backdrop-filter: blur(12px) !important;\n  -webkit-backdrop-filter: blur(12px) !important;\n  animation: offlineFadeIn 0.35s ease-out !important;\n}\n\n.offlineCard {\n  background: rgba(255, 255, 255, 0.03) !important;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  border-radius: 24px !important;\n  padding: 48px 32px !important;\n  max-width: 440px !important;\n  width: 90% !important;\n  text-align: center !important;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45) !important;\n  animation: offlineCardPop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;\n}\n\n.offlineRadarGroup {\n  position: relative !important;\n  width: 120px !important;\n  height: 120px !important;\n  margin: 0 auto 28px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.offlineRadarRing {\n  position: absolute !important;\n  border: 1.5px solid rgba(162, 174, 214, 0.15) !important;\n  border-radius: 50% !important;\n  animation: radarPulse 2s infinite linear !important;\n}\n\n.offlineRadarRing.ring-1 {\n  width: 120px !important;\n  height: 120px !important;\n  animation-delay: 0s !important;\n}\n\n.offlineRadarRing.ring-2 {\n  width: 90px !important;\n  height: 90px !important;\n  animation-delay: 0.6s !important;\n}\n\n.offlineIconWrapper {\n  width: 60px !important;\n  height: 60px !important;\n  border-radius: 50% !important;\n  background: rgba(255, 255, 255, 0.04) !important;\n  border: 1.5px solid rgba(255, 255, 255, 0.1) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  z-index: 2 !important;\n}\n\n.offlineIcon {\n  width: 32px !important;\n  height: 32px !important;\n  fill: none !important;\n  stroke: #c5cbe9 !important;\n  stroke-width: 2 !important;\n  stroke-linecap: round !important;\n}\n\n.offlineSlash {\n  stroke: #ff4b4b !important;\n  stroke-width: 2.5 !important;\n  filter: drop-shadow(0 0 4px rgba(255, 75, 75, 0.6)) !important;\n}\n\n.offlineTitle {\n  font-size: 26px !important;\n  font-weight: 700 !important;\n  color: #ffffff !important;\n  margin-bottom: 12px !important;\n  letter-spacing: -0.5px !important;\n}\n\n.offlineSubtitle {\n  font-size: 14.5px !important;\n  color: #a0aec0 !important;\n  line-height: 1.6 !important;\n  margin-bottom: 32px !important;\n  padding: 0 10px !important;\n}\n\n.offlineErrorBadge {\n  background: rgba(255, 75, 75, 0.1) !important;\n  border: 1px solid rgba(255, 75, 75, 0.25) !important;\n  color: #ff5c5c !important;\n  font-size: 12.5px !important;\n  font-weight: 600 !important;\n  padding: 8px 16px !important;\n  border-radius: 8px !important;\n  margin-bottom: 24px !important;\n  display: inline-block !important;\n  animation: offlineShake 0.4s ease-in-out !important;\n}\n\n.offlineRetryBtn {\n  width: 100% !important;\n  height: 48px !important;\n  border-radius: 12px !important;\n  background: linear-gradient(135deg, #3f47d4 0%, #2f3299 100%) !important;\n  color: #ffffff !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  border: none !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 10px !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  box-shadow: 0 4px 15px rgba(47, 50, 153, 0.3) !important;\n}\n\n.offlineRetryBtn:hover:not(:disabled) {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 6px 20px rgba(47, 50, 153, 0.5) !important;\n  background: linear-gradient(135deg, #4d56e6 0%, #3a3db3 100%) !important;\n}\n\n.offlineRetryBtn:active:not(:disabled) {\n  transform: translateY(0) !important;\n}\n\n.offlineRetryBtn:disabled {\n  opacity: 0.8 !important;\n  cursor: not-allowed !important;\n}\n\n/* Spinner for Loading State */\n.offlineSpinner {\n  width: 18px !important;\n  height: 18px !important;\n  animation: offlineRotate 1s linear infinite !important;\n}\n\n.offlineSpinner circle {\n  stroke: #ffffff !important;\n  stroke-linecap: round !important;\n  animation: offlineDash 1.5s ease-in-out infinite !important;\n}\n\n/* Animations */\n@keyframes offlineFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes offlineCardPop {\n  from {\n    transform: scale(0.9) translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes radarPulse {\n  0% {\n    transform: scale(0.5);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.1);\n    opacity: 0;\n  }\n}\n\n@keyframes offlineRotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes offlineDash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n\n@keyframes offlineShake {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(-5px);\n  }\n  75% {\n    transform: translateX(5px);\n  }\n}\n\n/* Custom Overrides: White background for Action Column on Assignment Page only */\n@media (min-width: 1000px) {\n  .assignmentTableWrapper td.row-fix-to-last,\n  .assignmentTableWrapper tr.skyBlueTrBg td.row-fix-to-last {\n    background-color: #ffffff !important;\n  }\n}\n\n/* Responsive Grid layout for settings page buttons on mobile */\n@media (max-width: 768px) {\n  .settingsBtnContainer {\n    display: grid !important;\n    grid-template-columns: 1fr 1fr !important;\n    gap: 10px !important;\n    width: 100% !important;\n  }\n\n  .settingsBtnContainer .borderButton,\n  .settingsBtnContainer .activeBorderButton,\n  .settingsBtnContainer .premiumReportBtn {\n    width: 100% !important;\n    min-width: 0 !important;\n    height: 38px !important;\n    font-size: 12px !important;\n    padding: 0 8px !important;\n    justify-content: center !important;\n    gap: 4px !important;\n  }\n\n  .settingsBtnContainer .borderButton svg,\n  .settingsBtnContainer .activeBorderButton svg,\n  .settingsBtnContainer .premiumReportBtn svg {\n    width: 14px !important;\n    height: 14px !important;\n  }\n\n  /* Compact Action buttons in tables on mobile */\n  td.row-fix-to-last {\n    gap: 6px !important;\n    padding: 6px 4px !important;\n  }\n\n  td.row-fix-to-last button,\n  td.row-fix-to-last .colorBtn {\n    padding: 4px 8px !important;\n    font-size: 11px !important;\n    height: auto !important;\n    min-height: 0 !important;\n    line-height: normal !important;\n    width: auto !important;\n    border-radius: 4px !important;\n  }\n\n  /* Premium Modal Container adjustments */\n  .premiumModalContent {\n    width: 95% !important;\n    max-width: 95vw !important;\n    max-height: 92vh !important;\n    padding: 12px 8px !important;\n    border-radius: 12px !important;\n  }\n\n  .premiumModalCloseBtn {\n    top: 14px !important;\n    right: 14px !important;\n    width: 28px !important;\n    height: 28px !important;\n    font-size: 16px !important;\n  }\n\n  .premiumModalContent .premiumFormContainer {\n    padding: 0 4px !important;\n  }\n\n  .premiumModalContent .premiumFormHeader {\n    margin-top: 4px !important;\n    margin-bottom: 12px !important;\n    padding-right: 28px !important;\n  }\n\n  .premiumModalContent .premiumFormHeader h2 {\n    font-size: 16px !important;\n    gap: 8px !important;\n  }\n\n  .premiumModalContent .premiumFormHeader h2 svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n\n  .premiumModalContent .premiumFormHeader p {\n    font-size: 11px !important;\n    margin-bottom: 0 !important;\n  }\n\n  .premiumModalContent .premiumFormCard {\n    padding: 10px 8px !important;\n    border-radius: 8px !important;\n    margin-bottom: 12px !important;\n  }\n\n  /* Form Labels & Fields Row Height */\n  .premiumModalContent .premiumFieldLabel,\n  .premiumModalContent .inputBoxWrapper label,\n  .custom-modal-container .inputBoxWrapper label {\n    font-size: 12.5px !important;\n    margin-bottom: 4px !important;\n  }\n\n  .premiumModalContent .premiumFormGrid,\n  .custom-modal-container .custom-grid-2 {\n    gap: 10px !important;\n  }\n\n  /* Text inputs, number inputs, selects, textareas scaling */\n  .premiumModalContent .inputBoxWrapper input,\n  .premiumModalContent .premiumInput,\n  .custom-modal-container .inputBoxWrapper input {\n    height: 36px !important;\n    font-size: 13px !important;\n    padding: 0 10px !important;\n    border-radius: 6px !important;\n  }\n\n  .premiumModalContent .inputBoxWrapper textarea,\n  .custom-modal-container .inputBoxWrapper textarea {\n    font-size: 13px !important;\n    padding: 8px 10px !important;\n    border-radius: 6px !important;\n    min-height: 70px !important;\n  }\n\n  /* React Select responsive size override inside modals */\n  .premiumModalContent [class*=\"-control\"],\n  .custom-modal-container [class*=\"-control\"] {\n    min-height: 36px !important;\n    height: auto !important;\n    border-radius: 6px !important;\n  }\n\n  .premiumModalContent [class*=\"-ValueContainer\"],\n  .custom-modal-container [class*=\"-ValueContainer\"] {\n    padding: 2px 6px !important;\n  }\n\n  .premiumModalContent [class*=\"-placeholder\"],\n  .premiumModalContent [class*=\"-singleValue\"],\n  .custom-modal-container [class*=\"-placeholder\"],\n  .custom-modal-container [class*=\"-singleValue\"] {\n    font-size: 13px !important;\n  }\n\n  /* Custom Time Picker responsive scaling */\n  .premiumModalContent .premiumTimePickerWrapper {\n    height: 36px !important;\n    padding: 0 8px !important;\n    border-radius: 6px !important;\n  }\n\n  .premiumModalContent .premiumTimePickerLabel {\n    font-size: 12.5px !important;\n  }\n\n  .premiumModalContent .premiumTimePickerCaret {\n    width: 12px !important;\n    height: 12px !important;\n  }\n\n  .premiumModalContent .premiumTimePickerWrapper svg {\n    width: 14px !important;\n    height: 14px !important;\n  }\n\n  /* Custom Date Picker responsive scaling */\n  .premiumModalContent .premiumDatePickerWrapper {\n    height: 36px !important;\n    padding: 0 8px !important;\n    border-radius: 6px !important;\n  }\n\n  .premiumModalContent .premiumDatePickerMiniLabel {\n    font-size: 10px !important;\n  }\n\n  .premiumModalContent .premiumDatePickerValue {\n    font-size: 12.5px !important;\n  }\n\n  .premiumModalContent .premiumDatePickerCaret {\n    width: 12px !important;\n    height: 12px !important;\n  }\n\n  .premiumModalContent .premiumDatePickerWrapper svg {\n    width: 14px !important;\n    height: 14px !important;\n  }\n\n  /* Submit & Cancel Buttons */\n  .premiumModalContent .premiumBtnCancel,\n  .premiumModalContent .premiumBtnSubmit {\n    height: 36px !important;\n    font-size: 12.5px !important;\n    border-radius: 6px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
